{
  "level": "q311",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q311",
    "objects": "AREAS.E3:q311.e3",
    "mesh": "TREES.E3:q311.e3"
  },
  "spawn_point": {
    "position": [
      750.4340835808099,
      1758.7012545731066,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      750.4340835808099,
      1858.7012545731066,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4714.04296875,
      -2598.9130859375,
      -300.0
    ],
    "bbox_max": [
      7600.0,
      7450.0,
      1783.6749267578125
    ],
    "vertex_count": 1482,
    "vertices": [
      [
        -3918.229736328125,
        -1600.0,
        1251.2120361328125
      ],
      [
        -3802.89990234375,
        -1600.0,
        151.26791381835938
      ],
      [
        -4714.04296875,
        -1600.000244140625,
        1446.2291259765625
      ],
      [
        -4356.13525390625,
        -1600.0,
        1314.8355712890625
      ],
      [
        -3679.27978515625,
        -1600.0,
        0.0
      ],
      [
        -3578.668701171875,
        -1600.0,
        -300.0
      ],
      [
        -3802.89990234375,
        -1600.0,
        151.26788330078125
      ],
      [
        -3679.27978515625,
        -1600.0,
        0.0
      ],
      [
        3885.714111328125,
        -1600.0,
        531.17138671875
      ],
      [
        5535.3330078125,
        -1600.0,
        752.41064453125
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2007.71044921875,
        793.1160278320312
      ],
      [
        2400.0,
        -1600.0,
        457.1454162597656
      ],
      [
        5742.85693359375,
        -1600.0,
        780.2428588867188
      ],
      [
        7600.0,
        -1600.0,
        852.5999755859375
      ],
      [
        5742.857421875,
        -1600.0,
        780.2428588867188
      ],
      [
        -3907.636962890625,
        -1600.0,
        1150.1849365234375
      ],
      [
        -3400.0,
        2940.080810546875,
        336.2261657714844
      ],
      [
        -3400.0,
        2786.4052734375,
        73.41243743896484
      ],
      [
        -3400.0,
        2993.050048828125,
        426.8134765625
      ],
      [
        6166.06201171875,
        5070.96826171875,
        1783.6749267578125
      ],
      [
        4117.16162109375,
        2301.5830078125,
        1016.0430908203125
      ],
      [
        4089.31982421875,
        3098.861328125,
        938.4326782226562
      ],
      [
        4104.1787109375,
        4205.02490234375,
        -300.0
      ],
      [
        4118.24951171875,
        2270.430419921875,
        1019.3637084960938
      ],
      [
        4117.16162109375,
        2301.583251953125,
        1016.0430908203125
      ],
      [
        6166.06201171875,
        5070.96826171875,
        1783.6749267578125
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.461669921875
      ],
      [
        6113.75048828125,
        5124.94384765625,
        1755.698974609375
      ],
      [
        4031.279296875,
        4760.92822265625,
        0.0
      ],
      [
        4044.14013671875,
        4392.6396484375,
        -300.0
      ],
      [
        6113.75048828125,
        5124.94384765625,
        1755.698974609375
      ],
      [
        4024.458251953125,
        4956.259765625,
        44.46170425415039
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.1990966796875
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7493286132812
      ],
      [
        4447.9970703125,
        5744.82666015625,
        939.7494506835938
      ],
      [
        4021.62939453125,
        5037.267578125,
        101.19913482666016
      ],
      [
        3988.998046875,
        5971.7080078125,
        711.0925903320312
      ],
      [
        4059.008056640625,
        3966.878662109375,
        0.0
      ],
      [
        4059.62060546875,
        3949.339111328125,
        65.54586791992188
      ],
      [
        4087.392822265625,
        3154.043701171875,
        933.0609741210938
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.716064453125
      ],
      [
        4529.33349609375,
        5879.8046875,
        1099.716064453125
      ],
      [
        3981.694580078125,
        6180.85302734375,
        847.5980224609375
      ],
      [
        3956.501220703125,
        6902.2900390625,
        1318.467529296875
      ],
      [
        4252.54541015625,
        -1575.3094482421875,
        538.225830078125
      ],
      [
        4253.40771484375,
        -1600.0,
        580.4847412109375
      ],
      [
        3108.39404296875,
        6871.484375,
        589.12548828125
      ],
      [
        2511.526123046875,
        6990.208984375,
        -22.699951171875
      ],
      [
        2511.526123046875,
        6990.208984375,
        171.574462890625
      ],
      [
        4029.05859375,
        4439.76806640625,
        -300.0
      ],
      [
        4024.77587890625,
        4947.1650390625,
        42.3914680480957
      ],
      [
        3671.12890625,
        4878.19677734375,
        -300.0
      ],
      [
        2504.6513671875,
        7187.068359375,
        696.7628173828125
      ],
      [
        2562.479736328125,
        5531.0810546875,
        141.3018798828125
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9072875976562
      ],
      [
        2511.52587890625,
        6990.208984375,
        630.7308959960938
      ],
      [
        3018.309814453125,
        6889.4033203125,
        624.2333374023438
      ],
      [
        2583.237548828125,
        4936.6591796875,
        -300.0
      ],
      [
        2580.06640625,
        5027.466796875,
        -27.623554229736328
      ],
      [
        4035.83935546875,
        4630.34521484375,
        -106.37001037597656
      ],
      [
        2572.77099609375,
        5236.3828125,
        53.799171447753906
      ],
      [
        2562.479736328125,
        5531.0810546875,
        141.30186462402344
      ],
      [
        2579.9189453125,
        5031.68798828125,
        -14.961797714233398
      ],
      [
        2511.52587890625,
        6990.208984375,
        642.9444580078125
      ],
      [
        2780.0,
        2051.5556640625,
        129.53280639648438
      ],
      [
        2953.59814453125,
        5034.9462890625,
        0.0
      ],
      [
        2948.912841796875,
        5033.93603515625,
        -3.095168113708496
      ],
      [
        2951.9765625,
        5034.95361328125,
        -1.1007986068725586
      ],
      [
        2970.07080078125,
        5066.6083984375,
        8.551486015319824
      ],
      [
        2907.568359375,
        5035.1591796875,
        -1.6254181861877441
      ],
      [
        2937.0,
        5080.740234375,
        12.31784439086914
      ],
      [
        2951.743896484375,
        5034.54638671875,
        -1.2249693870544434
      ],
      [
        2902.4248046875,
        5033.65283203125,
        -4.590198516845703
      ],
      [
        2907.179931640625,
        5034.55810546875,
        -1.8093819618225098
      ],
      [
        2910.27392578125,
        5035.14697265625,
        0.0
      ],
      [
        2511.52587890625,
        6990.208984375,
        976.300048828125
      ],
      [
        2579.744873046875,
        5036.67626953125,
        -5.498189926147461
      ],
      [
        2907.179931640625,
        5034.55810546875,
        -1.8093819618225098
      ],
      [
        2579.81591796875,
        5034.6416015625,
        -6.102384567260742
      ],
      [
        2579.744873046875,
        5036.67626953125,
        0.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        60.0
      ],
      [
        200.0,
        7450.0,
        60.0
      ],
      [
        200.0,
        7450.0,
        60.0
      ],
      [
        2511.526123046875,
        6990.208984375,
        60.0
      ],
      [
        348.975830078125,
        5355.8662109375,
        60.0
      ],
      [
        2572.041748046875,
        5257.26611328125,
        60.0
      ],
      [
        -195.03836059570312,
        5178.2353515625,
        0.0
      ],
      [
        -210.64198303222656,
        5380.6865234375,
        60.0
      ],
      [
        -170.80067443847656,
        7213.38623046875,
        60.0
      ],
      [
        -195.03836059570312,
        5178.2353515625,
        0.0
      ],
      [
        -99.99644470214844,
        4949.07666015625,
        -300.0
      ],
      [
        -184.02586364746094,
        5035.3515625,
        -42.34602355957031
      ],
      [
        -197.83628845214844,
        5049.53076171875,
        0.0
      ],
      [
        -217.4042510986328,
        5069.6220703125,
        60.0
      ],
      [
        -197.83628845214844,
        5049.53076171875,
        0.0
      ],
      [
        -417.7394104003906,
        3913.755859375,
        60.0
      ],
      [
        -219.95901489257812,
        4952.10302734375,
        60.0
      ],
      [
        -1850.0,
        1330.0,
        60.000003814697266
      ],
      [
        -2720.0,
        1330.0,
        60.0
      ],
      [
        -1850.0,
        1750.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1330.0,
        60.0
      ],
      [
        -219.95901489257812,
        4952.10302734375,
        60.0
      ],
      [
        -1840.0,
        1800.0,
        60.0
      ],
      [
        -1840.0,
        1750.0,
        60.0
      ],
      [
        -414.7947998046875,
        7327.70947265625,
        976.300048828125
      ],
      [
        -414.794677734375,
        7327.7099609375,
        60.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1851.7857666015625,
        1750.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        199.99978637695312
      ],
      [
        -1850.0,
        1750.0,
        225.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        225.0
      ],
      [
        1905.0,
        7190.8154296875,
        665.4798583984375
      ],
      [
        1905.0,
        6207.46875,
        333.7763366699219
      ],
      [
        2511.52587890625,
        6990.208984375,
        630.7308349609375
      ],
      [
        1905.0,
        7110.8544921875,
        60.0
      ],
      [
        1905.0,
        7110.8544921875,
        638.50732421875
      ],
      [
        1905.0,
        6207.46875,
        333.7763366699219
      ],
      [
        1905.0,
        5286.8515625,
        60.0
      ],
      [
        1905.0,
        7110.8544921875,
        976.300048828125
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.06494140625,
        1837.4248046875,
        1060.0
      ],
      [
        1975.4896240234375,
        1830.0,
        1060.0
      ],
      [
        1917.370849609375,
        1888.1185302734375,
        1060.0
      ],
      [
        1905.0,
        1940.0999755859375,
        1060.0
      ],
      [
        1905.0,
        1900.489501953125,
        1060.0
      ],
      [
        1968.06494140625,
        1837.4248046875,
        1060.0
      ],
      [
        1917.370849609375,
        1888.1185302734375,
        1060.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1905.0,
        1872.5831298828125,
        1130.0
      ],
      [
        1905.0,
        1838.6177978515625,
        1130.0
      ],
      [
        1913.6177978515625,
        1830.0,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1905.0,
        1868.943115234375,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1905.0,
        1868.943115234375,
        1060.0
      ],
      [
        1905.0,
        1830.0,
        1060.0
      ],
      [
        1905.0,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1760.0001220703125,
        1130.0
      ],
      [
        1910.0,
        1800.41455078125,
        1130.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1130.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      [
        1910.0,
        1812.9425048828125,
        1060.0
      ],
      [
        1910.0,
        1812.9427490234375,
        1106.0
      ],
      [
        1910.0,
        1768.0384521484375,
        1110.0
      ],
      [
        1910.0,
        1789.474365234375,
        1110.0
      ],
      [
        1910.0,
        1789.474365234375,
        1110.0
      ],
      [
        1910.0,
        1789.474365234375,
        1115.0
      ],
      [
        1905.0,
        1817.9425048828125,
        1060.0
      ],
      [
        1905.0,
        1817.9427490234375,
        1106.0
      ],
      [
        1905.0,
        1817.9425048828125,
        1060.0
      ],
      [
        1905.0,
        1817.9425048828125,
        1130.0
      ],
      [
        1905.0,
        1797.52783203125,
        1130.0
      ],
      [
        1905.0,
        1817.9425048828125,
        1130.0
      ],
      [
        1905.0,
        1797.52783203125,
        1130.0
      ],
      [
        1905.0,
        1776.027587890625,
        1130.0
      ],
      [
        1905.0,
        1766.69873046875,
        1110.0
      ],
      [
        1905.0,
        1788.1346435546875,
        1110.0
      ],
      [
        1905.0,
        1788.1346435546875,
        1110.0
      ],
      [
        1905.0,
        1788.1346435546875,
        1115.0
      ],
      [
        1210.0,
        6922.4560546875,
        537.2347412109375
      ],
      [
        1210.0,
        5317.6767578125,
        60.0
      ],
      [
        1905.0,
        7110.8544921875,
        602.4280395507812
      ],
      [
        1210.0,
        7249.0986328125,
        60.0
      ],
      [
        1210.0,
        7249.0986328125,
        634.3726806640625
      ],
      [
        1210.0,
        7195.15771484375,
        629.2227783203125
      ],
      [
        1210.0,
        6922.4560546875,
        537.2346801757812
      ],
      [
        1905.0,
        7110.8544921875,
        638.50732421875
      ],
      [
        1210.0,
        7249.0986328125,
        647.4180297851562
      ],
      [
        1210.0,
        7249.0986328125,
        976.300048828125
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      [
        1704.5103759765625,
        1830.0,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1814.6104736328125,
        1940.0999755859375,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1905.0,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1905.0,
        1867.4169921875,
        1130.0
      ],
      [
        1901.471435546875,
        1866.471435546875,
        1130.0
      ],
      [
        1905.0,
        1832.5833740234375,
        1130.0
      ],
      [
        1872.5,
        1841.2916259765625,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1905.0,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        1250.0,
        1630.0,
        429.0
      ],
      [
        1250.0,
        1630.0,
        379.0
      ],
      [
        1250.0,
        1690.0,
        379.0
      ],
      [
        1250.0,
        1630.0,
        379.0
      ],
      [
        1210.0,
        1690.0,
        379.0
      ],
      [
        1210.0,
        1630.0,
        379.0
      ],
      [
        1210.0,
        1630.0,
        429.0
      ],
      [
        1210.0,
        1630.0,
        379.0
      ],
      [
        1210.0,
        1610.0,
        259.0909118652344
      ],
      [
        1210.0,
        1610.0,
        329.0
      ],
      [
        650.0,
        6288.3056640625,
        341.2624816894531
      ],
      [
        650.0,
        5342.5146484375,
        60.0
      ],
      [
        1210.0,
        7249.0986328125,
        634.3726806640625
      ],
      [
        650.0,
        7360.4892578125,
        60.0
      ],
      [
        650.0,
        7360.4892578125,
        660.1118774414062
      ],
      [
        650.0,
        7360.4892578125,
        976.300048828125
      ],
      [
        1030.0,
        1463.6845703125,
        515.0
      ],
      [
        1030.0,
        1463.6845703125,
        80.0
      ],
      [
        1030.0,
        7196.28271484375,
        619.8324584960938
      ],
      [
        1030.0,
        7107.6328125,
        589.928955078125
      ],
      [
        1135.03955078125,
        1540.0,
        780.0
      ],
      [
        1135.03955078125,
        1540.0,
        515.0
      ],
      [
        1075.0,
        1496.3787841796875,
        515.0
      ],
      [
        1075.0,
        1496.3787841796875,
        780.0
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1540.0,
        370.0852355957031
      ],
      [
        1050.0,
        1478.21533203125,
        390.0852355957031
      ],
      [
        1030.0,
        1463.6845703125,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        650.0,
        1382.40087890625,
        140.0
      ],
      [
        650.0,
        1382.40087890625,
        160.0
      ],
      [
        650.0,
        1382.40087890625,
        520.0
      ],
      [
        650.0,
        1382.40087890625,
        550.0
      ],
      [
        650.0,
        1382.40087890625,
        100.0
      ],
      [
        650.0,
        1382.40087890625,
        140.0
      ],
      [
        650.0,
        1382.40087890625,
        160.0
      ],
      [
        650.0,
        1382.40087890625,
        520.0
      ],
      [
        780.0,
        1287.95068359375,
        80.0
      ],
      [
        780.0,
        1282.04931640625,
        80.0
      ],
      [
        777.1793212890625,
        1280.0,
        80.0
      ],
      [
        763.41552734375,
        1300.0,
        80.0
      ],
      [
        730.0,
        1324.2777099609375,
        80.0
      ],
      [
        713.2942504882812,
        1336.4150390625,
        80.0
      ],
      [
        740.0,
        1317.01220703125,
        80.0
      ],
      [
        760.0,
        1302.4814453125,
        80.0
      ],
      [
        760.0,
        1267.5185546875,
        80.0
      ],
      [
        740.0,
        1252.98779296875,
        80.0
      ],
      [
        780.0,
        1282.04931640625,
        80.0
      ],
      [
        780.0,
        1287.95068359375,
        80.0
      ],
      [
        784.061279296875,
        1285.0,
        80.0
      ],
      [
        740.0,
        1252.98779296875,
        78.0
      ],
      [
        740.0,
        1317.01220703125,
        78.0
      ],
      [
        740.0,
        1317.0123291015625,
        80.0
      ],
      [
        740.0,
        1252.98779296875,
        80.0
      ],
      [
        740.0,
        1317.0123291015625,
        78.0
      ],
      [
        760.0,
        1302.4814453125,
        78.0
      ],
      [
        780.0,
        1287.95068359375,
        78.0
      ],
      [
        780.0,
        1282.04931640625,
        78.0
      ],
      [
        784.061279296875,
        1285.0,
        78.0
      ],
      [
        780.0,
        1282.04931640625,
        78.0
      ],
      [
        780.0,
        1287.95068359375,
        78.0
      ],
      [
        780.0,
        1287.95068359375,
        80.0
      ],
      [
        780.0,
        1282.04931640625,
        80.0
      ],
      [
        763.41552734375,
        1300.0,
        78.0
      ],
      [
        763.41552734375,
        1300.0,
        80.0
      ],
      [
        780.0,
        1282.04931640625,
        60.0
      ],
      [
        780.0,
        1287.95068359375,
        60.0
      ],
      [
        784.061279296875,
        1285.0,
        60.4061279296875
      ],
      [
        777.1793212890625,
        1280.0,
        105.64138793945312
      ],
      [
        760.0,
        1267.5185546875,
        140.0
      ],
      [
        777.1792602539062,
        1280.0,
        140.0
      ],
      [
        777.1793212890625,
        1280.0,
        105.64138793945312
      ],
      [
        777.1793212890625,
        1280.0,
        140.0
      ],
      [
        760.0,
        1267.5185546875,
        140.0
      ],
      [
        839.914794921875,
        1325.579833984375,
        180.0
      ],
      [
        845.9986572265625,
        1330.0,
        186.08384704589844
      ],
      [
        845.9986572265625,
        1330.0,
        186.08384704589844
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        1000.0,
        1570.0,
        100.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        1000.0,
        1570.0,
        98.0
      ],
      [
        809.914794921875,
        1580.0,
        150.0
      ],
      [
        859.914794921875,
        1580.0,
        200.0
      ],
      [
        804.9573974609375,
        1594.9573974609375,
        145.0426025390625
      ],
      [
        809.914794921875,
        1590.0,
        150.0
      ],
      [
        940.0,
        1610.0,
        130.0000457763672
      ],
      [
        820.0,
        1610.0,
        130.0000457763672
      ],
      [
        810.0,
        1610.0,
        140.0
      ],
      [
        804.9573974609375,
        1665.0426025390625,
        145.0426025390625
      ],
      [
        804.9573974609375,
        1610.0,
        145.0426025390625
      ],
      [
        820.0,
        1610.0,
        130.0000457763672
      ],
      [
        820.0,
        1650.0,
        129.99993896484375
      ],
      [
        804.9573364257812,
        1655.025634765625,
        145.04261779785156
      ],
      [
        805.0,
        1655.0,
        145.0852508544922
      ],
      [
        805.0,
        1655.0,
        144.99996948242188
      ],
      [
        820.0,
        1640.0,
        100.0
      ],
      [
        780.0,
        1670.0,
        120.08523559570312
      ],
      [
        800.0,
        1690.0,
        140.08517456054688
      ],
      [
        780.0,
        1670.0,
        120.08523559570312
      ],
      [
        955.0,
        1605.0,
        135.00010681152344
      ],
      [
        945.0,
        1595.0,
        145.00006103515625
      ],
      [
        945.0,
        1595.0,
        145.00006103515625
      ],
      [
        954.0,
        1580.0,
        216.0
      ],
      [
        954.0,
        1580.0,
        160.00018310546875
      ],
      [
        804.9573974609375,
        1594.9573974609375,
        145.0426025390625
      ],
      [
        954.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        100.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        780.0,
        1590.0,
        120.08523559570312
      ],
      [
        790.0,
        1580.0,
        130.085205078125
      ],
      [
        800.0,
        1570.0,
        140.08517456054688
      ],
      [
        820.0,
        1311.1109619140625,
        64.0
      ],
      [
        818.4708251953125,
        1310.0,
        63.847084045410156
      ],
      [
        897.8049926757812,
        1367.6395263671875,
        71.7804946899414
      ],
      [
        942.3455200195312,
        1400.0,
        76.23455810546875
      ],
      [
        818.4708862304688,
        1310.0,
        63.847084045410156
      ],
      [
        804.7069091796875,
        1300.0,
        62.4706916809082
      ],
      [
        804.7069091796875,
        1300.0,
        62.4706916809082
      ],
      [
        942.3455810546875,
        1400.0,
        76.23455810546875
      ],
      [
        980.0,
        1427.3575439453125,
        80.0
      ],
      [
        980.0,
        1427.3575439453125,
        80.0
      ],
      [
        1011.1646728515625,
        1450.0,
        80.0
      ],
      [
        1011.1646728515625,
        1450.0,
        80.0
      ],
      [
        1030.0,
        1463.6845703125,
        80.0
      ],
      [
        737.914794921875,
        1437.706298828125,
        78.0
      ],
      [
        737.914794921875,
        1420.0,
        78.0
      ],
      [
        737.914794921875,
        1552.085205078125,
        78.0
      ],
      [
        737.914794921875,
        1437.706298828125,
        78.0
      ],
      [
        820.0,
        1311.1109619140625,
        78.0
      ],
      [
        739.914794921875,
        1420.0,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        1439.90625,
        80.0
      ],
      [
        739.914794921875,
        1550.085205078125,
        80.0
      ],
      [
        820.0,
        1311.1109619140625,
        80.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1540.0,
        78.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1311.1109619140625,
        80.0
      ],
      [
        820.0,
        1311.1109619140625,
        78.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1400.0,
        78.0
      ],
      [
        890.0,
        1400.0,
        78.0
      ],
      [
        890.0,
        1400.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        827.0,
        1440.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        78.0
      ],
      [
        790.0,
        1320.0,
        80.0
      ],
      [
        737.914794921875,
        1420.0,
        78.0
      ],
      [
        739.914794921875,
        1420.0,
        80.0
      ],
      [
        980.0,
        1427.3575439453125,
        100.0
      ],
      [
        998.9063110351562,
        1441.0936279296875,
        100.0
      ],
      [
        998.9063110351562,
        1441.0936279296875,
        100.0
      ],
      [
        1024.9285888671875,
        1460.0,
        100.0
      ],
      [
        897.8512573242188,
        1367.6732177734375,
        100.0
      ],
      [
        980.0,
        1427.3575439453125,
        100.0
      ],
      [
        998.9063110351562,
        1441.0936279296875,
        98.0
      ],
      [
        980.0,
        1427.3575439453125,
        98.0
      ],
      [
        1024.9285888671875,
        1460.0,
        98.0
      ],
      [
        998.9063110351562,
        1441.0936279296875,
        98.0
      ],
      [
        897.8512573242188,
        1367.6732177734375,
        98.0
      ],
      [
        980.0,
        1427.3575439453125,
        98.0
      ],
      [
        820.0,
        1540.0,
        98.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        820.0,
        1311.1109619140625,
        100.0
      ],
      [
        820.0,
        1311.1109619140625,
        98.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        820.0,
        1400.0,
        98.0
      ],
      [
        890.0,
        1400.0,
        98.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        883.0,
        1440.0,
        98.0
      ],
      [
        883.0,
        1404.0,
        98.0
      ],
      [
        883.0,
        1440.0,
        98.0
      ],
      [
        780.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        98.0
      ],
      [
        790.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1320.0,
        98.0
      ],
      [
        780.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        780.0,
        1310.0,
        98.0
      ],
      [
        780.0,
        1540.0,
        98.0
      ],
      [
        780.0,
        1540.0,
        100.0
      ],
      [
        780.0,
        1530.0,
        100.0
      ],
      [
        780.0,
        1530.0,
        98.0
      ],
      [
        882.9999389648438,
        1400.0,
        98.0
      ],
      [
        882.9999389648438,
        1450.0,
        98.0
      ],
      [
        839.914794921875,
        1540.0,
        180.0
      ],
      [
        839.914794921875,
        1472.8187255859375,
        180.0
      ],
      [
        839.914794921875,
        1570.0,
        180.0
      ],
      [
        839.914794921875,
        1540.0,
        180.0
      ],
      [
        820.0,
        1311.1109619140625,
        120.0
      ],
      [
        818.4708862304688,
        1310.0,
        120.0
      ],
      [
        780.0,
        1450.0,
        120.08523559570312
      ],
      [
        780.0,
        1540.0,
        120.08523559570312
      ],
      [
        780.0,
        1310.0,
        120.08523559570312
      ],
      [
        780.0,
        1400.0,
        120.08523559570312
      ],
      [
        780.0,
        1450.0,
        120.08523559570312
      ],
      [
        799.914794921875,
        1450.0,
        140.0
      ],
      [
        890.0,
        1450.0,
        120.0
      ],
      [
        820.0,
        1570.0,
        160.08518981933594
      ],
      [
        820.0,
        1540.0,
        160.08517456054688
      ],
      [
        799.914794921875,
        1400.0,
        140.0
      ],
      [
        780.0,
        1400.0,
        120.08523559570312
      ],
      [
        890.0,
        1400.0,
        120.0
      ],
      [
        799.914794921875,
        1450.0,
        140.0
      ],
      [
        799.914794921875,
        1400.0,
        140.0
      ],
      [
        820.0,
        1311.1109619140625,
        120.0
      ],
      [
        820.0,
        1311.1109619140625,
        64.0
      ],
      [
        719.9147338867188,
        1400.0,
        60.0
      ],
      [
        730.0,
        1400.0,
        70.08523559570312
      ],
      [
        719.914794921875,
        1450.0,
        60.0
      ],
      [
        726.6382446289062,
        1453.3616943359375,
        66.72349548339844
      ],
      [
        820.0,
        1311.1109619140625,
        180.0
      ],
      [
        818.4708862304688,
        1310.0,
        178.47085571289062
      ],
      [
        720.0,
        1420.0,
        78.0
      ],
      [
        720.0,
        1378.4161376953125,
        80.0
      ],
      [
        720.0,
        1400.0,
        80.0
      ],
      [
        720.0,
        1331.5430908203125,
        80.0
      ],
      [
        720.0,
        1378.4161376953125,
        80.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        78.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        721.0,
        1459.0,
        78.0
      ],
      [
        720.0,
        1459.0,
        78.0
      ],
      [
        730.0,
        1400.0,
        78.0
      ],
      [
        720.0,
        1400.0,
        80.0
      ],
      [
        720.0,
        1400.0,
        78.0
      ],
      [
        799.9999389648438,
        1580.0,
        150.0
      ],
      [
        795.0,
        1580.0,
        154.99998474121094
      ],
      [
        820.0,
        1580.0,
        180.0
      ],
      [
        839.914794921875,
        1580.0,
        180.0
      ],
      [
        795.0,
        1661.0,
        155.00001525878906
      ],
      [
        805.0,
        1655.0,
        165.00003051757812
      ],
      [
        804.9573364257812,
        1655.025634765625,
        145.0426025390625
      ],
      [
        800.0,
        1690.0,
        149.99996948242188
      ],
      [
        800.0,
        1690.0,
        160.0000457763672
      ],
      [
        795.0,
        1685.0,
        155.00001525878906
      ],
      [
        795.0,
        1575.0,
        155.00001525878906
      ],
      [
        800.0,
        1570.0,
        160.0000457763672
      ],
      [
        800.0,
        1570.0,
        149.99996948242188
      ],
      [
        840.0,
        1580.0,
        200.0
      ],
      [
        780.0,
        1590.0,
        140.00001525878906
      ],
      [
        799.914794921875,
        1570.085205078125,
        140.0
      ],
      [
        780.0,
        1670.0,
        140.00001525878906
      ],
      [
        799.914794921875,
        1689.914794921875,
        140.0
      ],
      [
        780.0,
        1670.0,
        140.00001525878906
      ],
      [
        799.9147338867188,
        1658.0511474609375,
        140.0
      ],
      [
        720.0,
        1450.0426025390625,
        60.085205078125
      ],
      [
        720.0,
        1400.0,
        60.08526611328125
      ],
      [
        700.0,
        1450.0,
        60.0
      ],
      [
        700.0,
        1400.0,
        60.0
      ],
      [
        718.0,
        1440.0,
        78.0
      ],
      [
        718.0,
        1420.0,
        78.0
      ],
      [
        718.0,
        1420.0,
        78.0
      ],
      [
        718.0,
        1440.0,
        78.0
      ],
      [
        650.0,
        1460.0,
        80.0
      ],
      [
        650.0,
        1460.0,
        190.0
      ],
      [
        790.0,
        1680.0,
        216.0
      ],
      [
        790.0,
        1680.0,
        150.00003051757812
      ],
      [
        790.0,
        1664.0,
        216.0
      ],
      [
        790.0,
        1664.0,
        150.00001525878906
      ],
      [
        790.0,
        1580.0,
        216.0
      ],
      [
        790.0,
        1580.0,
        150.00003051757812
      ],
      [
        650.0,
        1500.0,
        190.0
      ],
      [
        650.0,
        1460.0,
        190.0
      ],
      [
        650.0,
        1572.707275390625,
        190.0
      ],
      [
        650.0,
        1620.474609375,
        190.0
      ],
      [
        650.0,
        1572.707275390625,
        190.0
      ],
      [
        650.0,
        1500.0,
        190.0
      ],
      [
        780.0,
        1590.0,
        190.0
      ],
      [
        790.0,
        1580.0,
        190.0
      ],
      [
        780.0,
        1670.0,
        190.0
      ],
      [
        790.0,
        1680.0,
        190.0
      ],
      [
        780.0,
        1670.0,
        190.0
      ],
      [
        790.0,
        1664.0,
        190.0
      ],
      [
        650.0,
        1394.3714599609375,
        80.0
      ],
      [
        650.0,
        1400.0,
        80.0
      ],
      [
        650.0,
        1420.0,
        80.0
      ],
      [
        650.0,
        1440.0,
        80.0
      ],
      [
        650.0,
        1440.0,
        78.0
      ],
      [
        650.0,
        1420.0,
        78.0
      ],
      [
        650.0,
        1459.0,
        78.0
      ],
      [
        650.0,
        1460.0,
        80.0
      ],
      [
        718.0,
        1459.0,
        78.0
      ],
      [
        650.0,
        1420.0,
        78.0
      ],
      [
        650.0,
        1420.0,
        80.0
      ],
      [
        650.0,
        1440.0,
        80.0
      ],
      [
        650.0,
        1440.0,
        78.0
      ],
      [
        718.0,
        1400.0,
        78.0
      ],
      [
        650.0,
        1400.0,
        80.0
      ],
      [
        650.0,
        1400.0,
        78.0
      ],
      [
        650.0,
        1450.0,
        60.0
      ],
      [
        650.0,
        1400.0,
        60.0
      ],
      [
        650.0,
        1382.40087890625,
        100.0
      ],
      [
        650.0,
        1392.718994140625,
        83.30496978759766
      ],
      [
        650.0,
        1394.3714599609375,
        80.0
      ],
      [
        650.0,
        1392.718994140625,
        83.30496978759766
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1038.692626953125,
        1470.0,
        378.7778015136719
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.085205078125
      ],
      [
        1030.0,
        1463.6844482421875,
        370.085205078125
      ],
      [
        1024.9287109375,
        1460.0,
        365.013916015625
      ],
      [
        1024.9285888671875,
        1460.0,
        80.0
      ],
      [
        1030.0,
        1460.0,
        80.0
      ],
      [
        1075.0,
        1100.0,
        380.0
      ],
      [
        1075.0,
        1093.0,
        580.0
      ],
      [
        1152.4320068359375,
        1085.4320068359375,
        796.2268676757812
      ],
      [
        1154.050048828125,
        1087.050048828125,
        750.0
      ],
      [
        1075.0,
        1093.0,
        580.0
      ],
      [
        1075.0,
        1093.0,
        750.0
      ],
      [
        1075.0,
        1280.0,
        260.0
      ],
      [
        1075.0,
        1280.0,
        120.0
      ],
      [
        1075.0,
        1300.0,
        180.0
      ],
      [
        1075.0,
        1280.0,
        180.0
      ],
      [
        1030.0,
        970.0,
        380.0
      ],
      [
        1037.0,
        970.0,
        580.0
      ],
      [
        1044.56787109375,
        1072.43212890625,
        796.2268676757812
      ],
      [
        1042.949951171875,
        1074.050048828125,
        750.0
      ],
      [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      [
        1044.5675048828125,
        977.5806884765625,
        796.2144165039062
      ],
      [
        1042.949951171875,
        1093.0,
        750.0
      ],
      [
        1044.914306640625,
        1093.0,
        806.125732421875
      ],
      [
        1042.949951171875,
        1093.0,
        750.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1050.0,
        1380.0,
        390.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      [
        1030.0,
        1300.0,
        180.0
      ],
      [
        1030.0,
        1280.0,
        180.0
      ],
      [
        1037.0,
        970.0,
        580.0
      ],
      [
        1037.0,
        970.0,
        750.0
      ],
      [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      [
        1030.0,
        1058.743408203125,
        380.0
      ],
      [
        1030.0,
        970.0,
        380.0
      ],
      [
        1020.0,
        1062.5404052734375,
        130.0
      ],
      [
        861.3306884765625,
        1120.0,
        110.0
      ],
      [
        868.6693115234375,
        1120.0,
        110.0
      ],
      [
        950.0,
        1089.119140625,
        110.0
      ],
      [
        816.9432983398438,
        970.0,
        110.0
      ],
      [
        783.0529174804688,
        1045.0001220703125,
        110.0
      ],
      [
        807.7501220703125,
        1099.6556396484375,
        110.0
      ],
      [
        1010.0,
        970.0,
        110.0
      ],
      [
        1010.0,
        970.0,
        80.0
      ],
      [
        1010.0,
        1066.33740234375,
        80.0
      ],
      [
        1010.0,
        1066.33740234375,
        110.0
      ],
      [
        861.3306884765625,
        1120.0,
        60.0
      ],
      [
        868.6693115234375,
        1120.0,
        60.0
      ],
      [
        868.6693115234375,
        1120.0,
        110.0
      ],
      [
        861.3306884765625,
        1120.0,
        110.0
      ],
      [
        1010.0,
        1066.33740234375,
        130.0
      ],
      [
        1010.0,
        970.0,
        130.0
      ],
      [
        1020.0,
        1062.5404052734375,
        145.0
      ],
      [
        1010.0,
        970.0,
        130.0
      ],
      [
        1010.0,
        1066.3372802734375,
        130.0
      ],
      [
        980.0,
        1077.7281494140625,
        118.0
      ],
      [
        980.0,
        1077.7281494140625,
        120.0
      ],
      [
        805.0,
        1045.0,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        933.9188842773438,
        1073.831787109375,
        170.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        170.0
      ],
      [
        822.5736083984375,
        1083.890869140625,
        170.0
      ],
      [
        805.0,
        1045.0,
        170.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        170.0
      ],
      [
        865.0,
        1100.0001220703125,
        170.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        170.0
      ],
      [
        834.2426147460938,
        980.2852783203125,
        170.0
      ],
      [
        861.3309326171875,
        970.0,
        170.0
      ],
      [
        865.0,
        970.0,
        170.0
      ],
      [
        865.0,
        1100.0001220703125,
        170.0
      ],
      [
        822.5736083984375,
        1083.890869140625,
        170.0
      ],
      [
        865.0,
        970.0,
        170.0
      ],
      [
        868.6690673828125,
        970.0,
        170.0
      ],
      [
        794.0264282226562,
        1020.7152099609375,
        170.0
      ],
      [
        796.0811157226562,
        1073.831787109375,
        170.0
      ],
      [
        893.17138671875,
        1110.6966552734375,
        170.0
      ],
      [
        1017.9999389648438,
        1170.0,
        80.0
      ],
      [
        1017.9999389648438,
        1179.4866943359375,
        80.0
      ],
      [
        1030.0,
        1184.0430908203125,
        80.0
      ],
      [
        1010.0,
        1066.33740234375,
        110.0
      ],
      [
        1010.0,
        1120.0,
        110.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        896.7182006835938,
        1133.4364013671875,
        80.0
      ],
      [
        887.6677856445312,
        1130.0,
        80.0
      ],
      [
        993.0150146484375,
        1170.0,
        80.0
      ],
      [
        780.0,
        1089.1190185546875,
        110.0
      ],
      [
        780.0,
        1051.7562255859375,
        110.0
      ],
      [
        780.0,
        1051.7562255859375,
        60.0
      ],
      [
        780.0,
        1089.1190185546875,
        60.0
      ],
      [
        780.0,
        1051.7562255859375,
        110.0
      ],
      [
        780.0,
        1089.1190185546875,
        110.0
      ],
      [
        780.0,
        1089.1190185546875,
        110.0
      ],
      [
        780.0,
        1051.75634765625,
        110.0
      ],
      [
        765.58935546875,
        1083.6473388671875,
        110.0
      ],
      [
        765.58935546875,
        1083.6473388671875,
        108.0
      ],
      [
        780.0,
        1051.75634765625,
        108.0
      ],
      [
        780.0,
        1089.1190185546875,
        108.0
      ],
      [
        928.581787109375,
        1390.0,
        268.6669616699219
      ],
      [
        939.914794921875,
        1280.0,
        280.0
      ],
      [
        1030.0,
        1280.0,
        370.0852355957031
      ],
      [
        939.9147338867188,
        1280.0,
        280.0
      ],
      [
        910.0,
        1280.0,
        250.08526611328125
      ],
      [
        799.9147338867188,
        1280.0,
        140.0
      ],
      [
        777.1793212890625,
        1280.0,
        117.26458740234375
      ],
      [
        799.9147338867188,
        1280.0,
        140.0
      ],
      [
        799.9147338867188,
        1150.0,
        140.0
      ],
      [
        739.9147338867188,
        1150.0,
        80.0
      ],
      [
        737.9147338867188,
        1150.0,
        78.0
      ],
      [
        739.9147338867188,
        1150.0,
        80.0
      ],
      [
        743.1985473632812,
        1133.1986083984375,
        80.0
      ],
      [
        739.9147338867188,
        1140.4658203125,
        80.0
      ],
      [
        760.0,
        1096.016845703125,
        80.0
      ],
      [
        743.1985473632812,
        1133.1986083984375,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        861.3306884765625,
        1120.0,
        80.0
      ],
      [
        780.0,
        1089.1190185546875,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        769.9147338867188,
        1125.0426025390625,
        110.0
      ],
      [
        769.9147338867188,
        1085.2896728515625,
        110.0
      ],
      [
        767.9147338867188,
        1120.0,
        108.0
      ],
      [
        767.914794921875,
        1084.5302734375,
        108.0
      ],
      [
        769.9147338867188,
        1130.0,
        110.0
      ],
      [
        767.914794921875,
        1130.0,
        108.0
      ],
      [
        767.9147338867188,
        1126.0426025390625,
        108.0
      ],
      [
        773.304931640625,
        1277.18505859375,
        113.39020538330078
      ],
      [
        773.304931640625,
        1163.304931640625,
        113.39016723632812
      ],
      [
        910.0,
        1280.0,
        250.08526611328125
      ],
      [
        910.0,
        1190.0,
        250.08526611328125
      ],
      [
        840.0,
        1272.0,
        180.08523559570312
      ],
      [
        874.6409912109375,
        1252.0,
        214.72625732421875
      ],
      [
        805.3590087890625,
        1252.0,
        145.4442596435547
      ],
      [
        840.0,
        1272.0,
        180.08523559570312
      ],
      [
        805.3590087890625,
        1212.0,
        145.4442596435547
      ],
      [
        805.3590087890625,
        1252.0,
        145.4442596435547
      ],
      [
        980.0,
        1390.0,
        80.0
      ],
      [
        928.5816650390625,
        1390.0,
        74.85816955566406
      ],
      [
        980.0,
        1390.0,
        80.0
      ],
      [
        1030.0,
        1390.0,
        80.0
      ],
      [
        1000.0,
        1358.0,
        82.0
      ],
      [
        1010.0,
        1360.0,
        83.0
      ],
      [
        1000.0,
        1354.0,
        82.0
      ],
      [
        1000.0,
        1358.0,
        82.0
      ],
      [
        980.0,
        1390.0,
        98.0
      ],
      [
        933.002685546875,
        1325.1787109375,
        98.0
      ],
      [
        980.0,
        1390.0,
        98.0
      ],
      [
        933.002685546875,
        1390.0,
        98.0
      ],
      [
        945.5585327148438,
        1390.0,
        100.0
      ],
      [
        980.0,
        1390.0,
        100.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        807.4441528320312,
        1280.0,
        78.0
      ],
      [
        807.4441528320312,
        1301.9886474609375,
        78.0
      ],
      [
        820.0,
        1311.1109619140625,
        78.0
      ],
      [
        820.0,
        1311.1109619140625,
        80.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        78.0
      ],
      [
        839.914794921875,
        1280.0,
        180.0
      ],
      [
        839.914794921875,
        1310.0,
        180.0
      ],
      [
        820.0,
        1310.0,
        160.08522033691406
      ],
      [
        820.0,
        1280.0,
        160.08522033691406
      ],
      [
        928.58154296875,
        1390.0,
        100.0
      ],
      [
        928.58154296875,
        1390.0,
        98.0
      ],
      [
        820.0,
        1311.1109619140625,
        98.0
      ],
      [
        820.0,
        1311.1109619140625,
        100.0
      ],
      [
        820.0,
        1310.0,
        100.0
      ],
      [
        820.0,
        1310.0,
        98.0
      ],
      [
        910.0,
        1231.5853271484375,
        320.0
      ],
      [
        760.0,
        1096.0167236328125,
        108.0
      ],
      [
        760.0,
        1096.0167236328125,
        110.0
      ],
      [
        760.0,
        1096.0167236328125,
        108.0
      ],
      [
        760.0,
        1096.0167236328125,
        110.0
      ],
      [
        735.6065673828125,
        1150.0,
        80.0
      ],
      [
        735.6065673828125,
        1150.0,
        80.0
      ],
      [
        735.6065673828125,
        1150.0,
        78.0
      ],
      [
        740.0,
        970.0,
        78.0
      ],
      [
        740.0,
        970.0,
        80.0
      ],
      [
        740.0,
        1140.277099609375,
        80.0
      ],
      [
        760.0,
        970.0,
        80.0
      ],
      [
        740.0,
        970.0,
        80.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1051.7562255859375,
        80.0
      ],
      [
        650.0,
        980.0,
        190.0
      ],
      [
        650.0,
        1110.0,
        190.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        1094.0,
        120.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        1110.0,
        120.0
      ],
      [
        650.0,
        1150.0,
        80.0
      ],
      [
        650.0,
        1130.0,
        80.0
      ],
      [
        720.0,
        970.0,
        80.0
      ],
      [
        650.0,
        970.0,
        80.0
      ],
      [
        650.0,
        980.0,
        80.0
      ],
      [
        650.0,
        1150.0,
        80.0
      ],
      [
        650.0,
        1150.0,
        78.0
      ],
      [
        650.0,
        1120.0,
        60.0
      ],
      [
        650.0,
        1110.0,
        80.0
      ],
      [
        650.0,
        1110.0,
        80.0
      ],
      [
        650.0,
        1110.0,
        120.0
      ],
      [
        650.0,
        1110.0,
        160.0
      ],
      [
        650.0,
        1090.0,
        160.0
      ],
      [
        650.0,
        1110.0,
        160.0
      ],
      [
        650.0,
        1110.0,
        190.0
      ],
      [
        650.0,
        1090.0,
        160.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        940.0,
        80.0
      ],
      [
        650.0,
        930.0,
        60.0
      ],
      [
        650.0,
        920.0,
        80.0
      ],
      [
        866.3075561523438,
        720.0,
        140.0
      ],
      [
        866.3075561523438,
        720.0,
        120.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1020.4000244140625,
        970.0,
        140.0
      ],
      [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      [
        1016.6666870117188,
        970.0,
        140.0
      ],
      [
        760.0,
        720.0,
        140.0
      ],
      [
        760.0,
        720.0,
        220.0
      ],
      [
        760.0,
        720.0,
        220.0
      ],
      [
        767.9136962890625,
        720.0,
        256.9305725097656
      ],
      [
        866.3075561523438,
        720.0,
        170.0
      ],
      [
        1024.6068115234375,
        944.6067504882812,
        245.1685333251953
      ],
      [
        1020.4000244140625,
        950.0,
        140.0
      ],
      [
        1023.6000366210938,
        950.0,
        220.00006103515625
      ],
      [
        1020.4000244140625,
        967.1428833007812,
        140.0
      ],
      [
        1017.0270385742188,
        967.0270385742188,
        140.54055786132812
      ],
      [
        1016.6666870117188,
        967.1428833007812,
        140.0
      ],
      [
        1905.0,
        -1277.2857666015625,
        252.5999755859375
      ],
      [
        1905.0,
        -1600.0,
        399.28826904296875
      ],
      [
        1290.0,
        -1435.4285888671875,
        252.5999755859375
      ],
      [
        1290.0,
        -1600.0,
        327.4051513671875
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        866.3075561523438,
        720.0,
        140.0
      ],
      [
        1210.0,
        -1456.0,
        252.5999755859375
      ],
      [
        1210.0,
        -1600.0,
        318.05450439453125
      ],
      [
        840.0,
        -1551.142822265625,
        252.5999755859375
      ],
      [
        840.0,
        -1600.0,
        274.8077697753906
      ],
      [
        602.2073974609375,
        1394.3714599609375,
        80.0
      ],
      [
        602.2073974609375,
        1400.0,
        80.0
      ],
      [
        602.2073974609375,
        1130.0,
        80.0
      ],
      [
        602.2073974609375,
        1150.0,
        80.0
      ],
      [
        602.2073974609375,
        1420.0,
        80.0
      ],
      [
        602.2073974609375,
        1440.0,
        80.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        80.0
      ],
      [
        602.2073974609375,
        1460.0,
        80.0
      ],
      [
        602.2073974609375,
        940.0,
        80.0
      ],
      [
        602.2073974609375,
        980.0,
        80.0
      ],
      [
        -226.6120147705078,
        4952.80419921875,
        79.99999237060547
      ],
      [
        -177.73423767089844,
        7201.181640625,
        80.0
      ],
      [
        -423.65252685546875,
        3918.34130859375,
        79.99999237060547
      ],
      [
        -226.6120147705078,
        4952.80419921875,
        80.0
      ],
      [
        -167.24493408203125,
        7376.95068359375,
        60.0
      ],
      [
        -414.794677734375,
        7327.7099609375,
        80.0
      ],
      [
        -173.94216918945312,
        7375.61865234375,
        80.0
      ],
      [
        -533.3333129882812,
        1413.3333740234375,
        80.0
      ],
      [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      [
        -296.9612731933594,
        1410.0,
        60.0
      ],
      [
        -300.0,
        1411.5357666015625,
        69.21420288085938
      ],
      [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      [
        -350.0,
        1430.0,
        80.0
      ],
      [
        -533.3333129882812,
        1250.0,
        80.0
      ],
      [
        -533.3333129882812,
        1413.3333740234375,
        80.0
      ],
      [
        310.0,
        540.0,
        60.0
      ],
      [
        310.0,
        540.0,
        80.0
      ],
      [
        310.0,
        970.0,
        80.0
      ],
      [
        200.0,
        7450.0,
        80.0
      ],
      [
        260.0,
        1250.0,
        80.0
      ],
      [
        260.0,
        1300.0,
        80.0
      ],
      [
        260.0,
        1500.0,
        80.0
      ],
      [
        260.0,
        1300.0,
        80.0
      ],
      [
        260.0,
        1000.0,
        80.0
      ],
      [
        260.0,
        1250.0,
        80.0
      ],
      [
        -300.0,
        1413.3333740234375,
        80.0
      ],
      [
        -66.66666412353516,
        1413.3333740234375,
        80.0
      ],
      [
        200.0,
        7450.0,
        80.0
      ],
      [
        260.0,
        7438.0654296875,
        80.0
      ],
      [
        260.0,
        7438.0654296875,
        60.0
      ],
      [
        -50.0,
        1410.0,
        60.0
      ],
      [
        -50.0,
        1413.3333740234375,
        80.0
      ],
      [
        -50.0,
        1430.0,
        80.0
      ],
      [
        -50.0,
        1250.0,
        80.0
      ],
      [
        120.0,
        1240.0,
        75.0
      ],
      [
        120.0,
        1240.0,
        79.99999237060547
      ],
      [
        120.0,
        1250.0,
        80.0
      ],
      [
        120.0,
        1250.0,
        75.0
      ],
      [
        120.0,
        1249.3782958984375,
        75.0
      ],
      [
        120.0,
        1249.3782958984375,
        60.0
      ],
      [
        270.0,
        1240.0,
        78.0
      ],
      [
        310.0,
        1240.0,
        78.0
      ],
      [
        310.0,
        1291.25,
        78.0
      ],
      [
        270.0,
        1306.25,
        78.0
      ],
      [
        270.0,
        1306.25,
        78.0
      ],
      [
        310.0,
        1291.25,
        78.0
      ],
      [
        310.0,
        1310.0,
        78.0
      ],
      [
        270.0,
        1310.0,
        78.0
      ],
      [
        270.0,
        1440.0,
        78.0
      ],
      [
        310.0,
        1440.0,
        78.0
      ],
      [
        310.0,
        1460.0,
        78.0
      ],
      [
        270.0,
        1460.0,
        78.0
      ],
      [
        270.0,
        7436.076171875,
        80.0
      ],
      [
        310.0,
        7428.11962890625,
        80.0
      ],
      [
        310.0,
        7428.11962890625,
        78.0
      ],
      [
        270.0,
        7436.076171875,
        78.0
      ],
      [
        310.0,
        1416.0,
        78.0
      ],
      [
        310.0,
        1415.0,
        80.0
      ],
      [
        270.0,
        1416.0,
        78.0
      ],
      [
        270.0,
        1309.0,
        78.0
      ],
      [
        310.0,
        1310.0,
        80.0
      ],
      [
        310.0,
        1309.0,
        78.0
      ],
      [
        270.0,
        1310.0,
        78.0
      ],
      [
        310.0,
        1310.0,
        78.0
      ],
      [
        310.0,
        1310.0,
        80.0
      ],
      [
        270.0,
        1310.0,
        80.0
      ],
      [
        310.0,
        1241.0,
        78.0
      ],
      [
        310.0,
        1240.0,
        80.0
      ],
      [
        270.0,
        1240.0,
        80.0
      ],
      [
        270.0,
        1241.0,
        78.0
      ],
      [
        270.0,
        1459.0,
        78.0
      ],
      [
        270.0,
        1460.0,
        80.0
      ],
      [
        310.0,
        1460.0,
        80.0
      ],
      [
        310.0,
        1459.0,
        78.0
      ],
      [
        310.0,
        1440.0,
        78.0
      ],
      [
        270.0,
        1440.0,
        78.0
      ],
      [
        270.0,
        1440.0,
        80.0
      ],
      [
        310.0,
        1440.0,
        80.0
      ],
      [
        310.0,
        1425.0,
        60.0
      ],
      [
        270.0,
        1250.0,
        60.0
      ],
      [
        310.0,
        1250.0,
        60.0
      ],
      [
        310.0,
        1300.0,
        60.0
      ],
      [
        310.0,
        1450.0,
        60.0
      ],
      [
        270.0,
        1450.0,
        60.0
      ],
      [
        310.0,
        7428.11962890625,
        60.0
      ],
      [
        270.0,
        7436.076171875,
        60.0
      ],
      [
        270.0,
        7436.076171875,
        78.0
      ],
      [
        260.0,
        7438.0654296875,
        78.0
      ],
      [
        270.0,
        1241.0,
        78.0
      ],
      [
        260.0,
        1241.0,
        78.0
      ],
      [
        260.0,
        1459.0,
        78.0
      ],
      [
        270.0,
        1459.0,
        78.0
      ],
      [
        602.2073974609375,
        7369.99560546875,
        80.0
      ],
      [
        602.2073974609375,
        7369.99560546875,
        60.0
      ],
      [
        370.38104248046875,
        5422.169921875,
        80.0
      ],
      [
        602.2073974609375,
        5411.8876953125,
        80.0
      ],
      [
        602.2073974609375,
        5344.63427734375,
        60.0
      ],
      [
        602.2073974609375,
        930.0,
        60.0
      ],
      [
        602.2073974609375,
        920.0,
        80.0
      ],
      [
        360.0,
        921.0000610351562,
        78.0
      ],
      [
        360.0,
        920.0,
        80.0
      ],
      [
        500.0,
        1120.0,
        60.0
      ],
      [
        602.2073974609375,
        1120.0,
        60.0
      ],
      [
        602.2073974609375,
        1110.0,
        80.0
      ],
      [
        500.0,
        1110.0,
        80.0
      ],
      [
        602.2073974609375,
        1400.0,
        60.0
      ],
      [
        602.2073974609375,
        1400.0,
        80.0
      ],
      [
        602.2073974609375,
        1150.0,
        78.0
      ],
      [
        602.2073974609375,
        1130.0,
        78.0
      ],
      [
        602.2073974609375,
        1150.0,
        78.0
      ],
      [
        602.2073974609375,
        1150.0,
        80.0
      ],
      [
        602.2073974609375,
        1450.0,
        60.0
      ],
      [
        602.2073974609375,
        1460.0,
        80.0
      ],
      [
        550.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        550.0,
        1459.0,
        78.0
      ],
      [
        602.2073974609375,
        1420.0,
        78.0
      ],
      [
        602.2073974609375,
        1420.0,
        80.0
      ],
      [
        602.2073974609375,
        1440.0,
        78.0
      ],
      [
        602.2073974609375,
        1420.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        602.2073974609375,
        1440.0,
        80.0
      ],
      [
        602.2073974609375,
        1440.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        480.0,
        1460.0,
        78.0
      ],
      [
        500.0,
        1111.0,
        78.0
      ],
      [
        480.0,
        1110.0,
        80.0
      ],
      [
        480.0,
        1111.0,
        78.0
      ],
      [
        480.0,
        1459.0,
        78.0
      ],
      [
        480.0,
        1460.0,
        80.0
      ],
      [
        500.0,
        1459.0,
        78.0
      ],
      [
        480.0,
        1120.0,
        60.0
      ],
      [
        480.0,
        1450.0,
        60.0
      ],
      [
        395.0,
        1459.0001220703125,
        78.0
      ],
      [
        480.0,
        1459.0001220703125,
        78.0
      ],
      [
        395.0,
        1459.0001220703125,
        78.0
      ],
      [
        310.0,
        1459.0001220703125,
        78.0
      ],
      [
        400.0,
        1309.0,
        78.0
      ],
      [
        310.0,
        1309.0,
        78.0
      ],
      [
        400.0,
        1309.0,
        78.0
      ],
      [
        400.0,
        1415.9998779296875,
        78.0
      ],
      [
        390.9998474121094,
        1415.9998779296875,
        78.0
      ],
      [
        390.0,
        1415.9998779296875,
        78.0
      ],
      [
        390.9998474121094,
        1415.9998779296875,
        78.0
      ],
      [
        400.0,
        1415.9998779296875,
        78.0
      ],
      [
        404.0,
        1415.0,
        80.0
      ],
      [
        390.0,
        1415.9998779296875,
        78.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        310.0,
        1280.0,
        78.0
      ],
      [
        340.0,
        1240.9998779296875,
        78.0
      ],
      [
        310.0,
        1240.9998779296875,
        78.0
      ],
      [
        340.0,
        1240.9998779296875,
        78.0
      ],
      [
        480.0,
        1111.0,
        78.0
      ],
      [
        477.0,
        1110.0,
        80.0
      ],
      [
        477.0,
        1120.0,
        80.0
      ],
      [
        477.0,
        1120.0,
        80.0
      ],
      [
        -173.942138671875,
        7375.61865234375,
        80.0
      ],
      [
        -414.7947692871094,
        7327.70947265625,
        799.2634887695312
      ],
      [
        -434.5,
        1219.021728515625,
        460.0666809082031
      ],
      [
        -447.8142395019531,
        1219.021728515625,
        500.0
      ],
      [
        -399.5,
        1158.39990234375,
        351.13873291015625
      ],
      [
        -434.5,
        1219.021728515625,
        460.0666198730469
      ],
      [
        550.0,
        7380.38037109375,
        976.300048828125
      ],
      [
        550.0,
        7380.38037109375,
        80.0
      ],
      [
        550.0,
        5978.5498046875,
        247.82728576660156
      ],
      [
        550.0,
        5414.203125,
        80.0
      ],
      [
        310.0,
        540.0,
        420.0
      ],
      [
        -379.50006103515625,
        1123.759033203125,
        400.0
      ],
      [
        -399.5,
        1158.39990234375,
        400.0
      ],
      [
        -309.5,
        1210.361328125,
        400.0
      ],
      [
        -309.5,
        1101.0794677734375,
        400.0
      ],
      [
        -309.5,
        1210.361328125,
        450.0
      ],
      [
        -309.5,
        1210.361328125,
        400.0
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        -295.0,
        1219.021728515625,
        80.0
      ],
      [
        -295.0,
        1219.021728515625,
        125.0
      ],
      [
        -260.53472900390625,
        1420.0,
        120.0
      ],
      [
        -256.6857604980469,
        1413.3333740234375,
        80.0
      ],
      [
        -260.53472900390625,
        1420.0,
        120.0
      ],
      [
        -266.3082580566406,
        1430.0,
        120.0
      ],
      [
        260.0,
        1578.7005615234375,
        240.0
      ],
      [
        260.0,
        1604.025634765625,
        240.0
      ],
      [
        260.0,
        1578.7005615234375,
        240.0
      ],
      [
        -66.33332824707031,
        1413.666748046875,
        82.0
      ],
      [
        -256.8782043457031,
        1413.666748046875,
        82.0
      ],
      [
        -50.0,
        1413.6666259765625,
        82.0
      ],
      [
        -50.0,
        1430.0,
        82.0
      ],
      [
        -50.0,
        1413.3333740234375,
        80.0
      ],
      [
        -50.0,
        1250.0,
        82.0
      ],
      [
        22.5,
        1270.0,
        82.0
      ],
      [
        97.5,
        1270.0,
        82.0
      ],
      [
        120.0,
        1250.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        97.5,
        1270.0,
        82.0
      ],
      [
        120.0,
        1240.0,
        82.0
      ],
      [
        120.0,
        1250.0,
        82.0
      ],
      [
        -50.0,
        1420.0,
        120.0
      ],
      [
        -50.0,
        1413.666748046875,
        82.0
      ],
      [
        22.5,
        1270.0,
        120.0
      ],
      [
        97.5,
        1270.0,
        120.0
      ],
      [
        120.0,
        1250.0,
        112.15384674072266
      ],
      [
        120.0,
        1250.0,
        120.0
      ],
      [
        110.0,
        1265.0,
        120.0
      ],
      [
        110.0,
        1265.0,
        108.76923370361328
      ],
      [
        110.0,
        1265.0,
        108.76923370361328
      ],
      [
        110.0,
        1265.0,
        120.0
      ],
      [
        97.5,
        1270.0,
        120.0
      ],
      [
        97.5,
        1270.0,
        104.53845977783203
      ],
      [
        120.0,
        1240.0,
        112.15384674072266
      ],
      [
        120.0,
        1240.0,
        120.0
      ],
      [
        120.0,
        1250.0,
        120.0
      ],
      [
        120.0,
        1250.0,
        112.15385437011719
      ],
      [
        110.0,
        1316.54541015625,
        126.0
      ],
      [
        110.0,
        1490.0,
        126.0
      ],
      [
        10.0,
        1316.54541015625,
        126.0
      ],
      [
        110.0,
        1316.54541015625,
        126.0
      ],
      [
        22.5,
        1270.0,
        126.0
      ],
      [
        97.5,
        1270.0,
        126.0
      ],
      [
        110.0,
        1265.0,
        126.0
      ],
      [
        97.5,
        1270.0,
        126.0
      ],
      [
        120.0,
        1250.0,
        126.0
      ],
      [
        110.0,
        1265.0,
        126.0
      ],
      [
        120.0,
        1240.0,
        126.0
      ],
      [
        120.0,
        1250.0,
        126.0
      ],
      [
        110.0,
        1348.1817626953125,
        155.0
      ],
      [
        110.0,
        1490.0,
        155.0
      ],
      [
        10.0,
        1348.1817626953125,
        155.0
      ],
      [
        110.0,
        1348.1817626953125,
        155.0
      ],
      [
        22.5,
        1270.0,
        155.0
      ],
      [
        97.5,
        1270.0,
        155.0
      ],
      [
        110.0,
        1265.0,
        155.0
      ],
      [
        97.5,
        1270.0,
        155.0
      ],
      [
        120.0,
        1250.0,
        139.87289428710938
      ],
      [
        110.0,
        1265.0,
        139.87289428710938
      ],
      [
        120.0,
        1240.0,
        139.87289428710938
      ],
      [
        120.0,
        1250.0,
        139.87289428710938
      ],
      [
        120.0,
        1250.0,
        155.0
      ],
      [
        110.0,
        1265.0,
        155.0
      ],
      [
        120.0,
        1240.0,
        155.0
      ],
      [
        120.0,
        1250.0,
        155.0
      ],
      [
        310.0,
        1240.0,
        120.0
      ],
      [
        310.0,
        1240.0,
        140.0
      ],
      [
        310.0,
        1240.0,
        100.0
      ],
      [
        310.0,
        1240.0,
        120.0
      ],
      [
        310.0,
        1240.0,
        80.0
      ],
      [
        310.0,
        1240.0,
        100.0
      ],
      [
        310.0,
        1240.0,
        140.0
      ],
      [
        310.0,
        1240.0,
        190.0
      ],
      [
        310.0,
        1240.0,
        190.0
      ],
      [
        310.0,
        1240.0,
        340.0
      ],
      [
        270.0,
        1460.0,
        190.0
      ],
      [
        270.0,
        1460.0,
        240.0
      ],
      [
        310.0,
        1460.0,
        120.0
      ],
      [
        270.0,
        1460.0,
        120.0
      ],
      [
        270.0,
        1460.0,
        140.0
      ],
      [
        310.0,
        1460.0,
        140.0
      ],
      [
        310.0,
        1460.0,
        80.0
      ],
      [
        270.0,
        1460.0,
        80.0
      ],
      [
        270.0,
        1460.0,
        120.0
      ],
      [
        310.0,
        1460.0,
        120.0
      ],
      [
        310.0,
        1460.0,
        140.0
      ],
      [
        270.0,
        1460.0,
        140.0
      ],
      [
        270.0,
        1460.0,
        190.0
      ],
      [
        310.0,
        1460.0,
        190.0
      ],
      [
        270.0,
        1460.0,
        334.7368469238281
      ],
      [
        310.0,
        1460.0,
        313.6842041015625
      ],
      [
        310.0,
        1460.0,
        240.0
      ],
      [
        270.0,
        1460.0,
        240.0
      ],
      [
        310.0,
        1460.0,
        313.6842041015625
      ],
      [
        270.0,
        1460.0,
        334.7368469238281
      ],
      [
        270.0,
        1472.105224609375,
        340.0
      ],
      [
        310.0,
        1520.5263671875,
        340.0
      ],
      [
        270.0,
        1550.2734375,
        240.0
      ],
      [
        270.0,
        1574.5584716796875,
        240.0
      ],
      [
        270.0,
        1618.99169921875,
        240.0
      ],
      [
        270.0,
        1574.5584716796875,
        240.0
      ],
      [
        310.0,
        1625.8948974609375,
        240.0
      ],
      [
        310.0,
        1640.0001220703125,
        240.0
      ],
      [
        310.0,
        1310.0,
        140.0
      ],
      [
        310.0,
        1310.0,
        100.0
      ],
      [
        310.0,
        1310.0,
        140.0
      ],
      [
        310.0,
        1310.0,
        180.0
      ],
      [
        310.0,
        1310.0,
        80.0
      ],
      [
        310.0,
        1310.0,
        100.0
      ],
      [
        310.0,
        1310.0,
        240.0
      ],
      [
        310.0,
        1310.0,
        180.0
      ],
      [
        310.0,
        1415.0,
        190.0
      ],
      [
        310.0,
        1460.0,
        190.0
      ],
      [
        300.0,
        1415.0,
        100.0
      ],
      [
        310.0,
        1415.0,
        100.0
      ],
      [
        310.0,
        1415.0,
        140.0
      ],
      [
        300.0,
        1415.0,
        140.0
      ],
      [
        300.0,
        1415.0,
        140.0
      ],
      [
        310.0,
        1415.0,
        140.0
      ],
      [
        310.0,
        1415.0,
        180.0
      ],
      [
        300.0,
        1415.0,
        180.0
      ],
      [
        300.0,
        1415.0,
        180.0
      ],
      [
        310.0,
        1415.0,
        180.0
      ],
      [
        310.0,
        1415.0,
        190.0
      ],
      [
        300.0,
        1415.0,
        190.0
      ],
      [
        300.0,
        1415.0,
        80.0
      ],
      [
        310.0,
        1415.0,
        80.0
      ],
      [
        310.0,
        1415.0,
        100.0
      ],
      [
        300.0,
        1415.0,
        100.0
      ],
      [
        550.0,
        1209.3953857421875,
        140.0
      ],
      [
        550.0,
        1209.3953857421875,
        160.0
      ],
      [
        550.0,
        1209.3953857421875,
        520.0
      ],
      [
        550.0,
        1209.3953857421875,
        550.0
      ],
      [
        550.0,
        1209.3953857421875,
        100.0
      ],
      [
        550.0,
        1209.3953857421875,
        140.0
      ],
      [
        550.0,
        1209.3953857421875,
        160.0
      ],
      [
        550.0,
        1209.3953857421875,
        520.0
      ],
      [
        550.0,
        1360.6046142578125,
        140.0
      ],
      [
        550.0,
        1360.6046142578125,
        160.0
      ],
      [
        550.0,
        1360.6046142578125,
        520.0
      ],
      [
        550.0,
        1360.6046142578125,
        550.0
      ],
      [
        550.0,
        1360.6046142578125,
        100.0
      ],
      [
        550.0,
        1360.6046142578125,
        140.0
      ],
      [
        550.0,
        1360.6046142578125,
        160.0
      ],
      [
        550.0,
        1360.6046142578125,
        520.0
      ],
      [
        535.7269287109375,
        1362.5953369140625,
        80.0
      ],
      [
        550.0,
        1372.96533203125,
        80.0
      ],
      [
        550.0,
        1360.6046142578125,
        100.0
      ],
      [
        550.0,
        1197.03466796875,
        80.0
      ],
      [
        535.7269287109375,
        1207.4046630859375,
        80.0
      ],
      [
        550.0,
        1209.3953857421875,
        100.0
      ],
      [
        450.0,
        1471.2445068359375,
        80.0
      ],
      [
        450.0,
        1471.2445068359375,
        120.0
      ],
      [
        450.0,
        1471.2445068359375,
        190.0
      ],
      [
        450.0,
        1471.244384765625,
        240.0
      ],
      [
        450.0,
        1471.2445068359375,
        240.0
      ],
      [
        450.0,
        1471.244384765625,
        244.88888549804688
      ],
      [
        450.0,
        1471.2445068359375,
        244.88890075683594
      ],
      [
        398.9866943359375,
        1628.2470703125,
        340.0
      ],
      [
        374.09832763671875,
        1704.845458984375,
        240.0
      ],
      [
        383.2369384765625,
        1676.719970703125,
        240.0
      ],
      [
        420.0,
        1563.574951171875,
        105.0
      ],
      [
        411.0671691894531,
        1591.067138671875,
        118.39922332763672
      ],
      [
        426.66668701171875,
        1600.0,
        95.0
      ],
      [
        426.66668701171875,
        1580.0,
        95.0
      ],
      [
        434.15838623046875,
        1520.0,
        95.0
      ],
      [
        440.65679931640625,
        1500.0,
        95.0
      ],
      [
        437.4075927734375,
        1510.0,
        140.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        450.0,
        1495.0,
        140.0
      ],
      [
        442.2814025878906,
        1495.0,
        140.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        437.4075927734375,
        1510.0,
        150.0
      ],
      [
        442.2814025878906,
        1495.0,
        150.0
      ],
      [
        450.0,
        1495.0,
        150.0
      ],
      [
        437.4075927734375,
        1510.0,
        150.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        437.4075927734375,
        1510.0,
        140.0
      ],
      [
        442.2814025878906,
        1495.0,
        140.0
      ],
      [
        450.0,
        1495.0,
        140.0
      ],
      [
        450.0,
        1495.0,
        150.0
      ],
      [
        442.2814025878906,
        1495.0,
        150.0
      ],
      [
        426.66668701171875,
        1580.0,
        95.0
      ],
      [
        436.6667175292969,
        1580.0,
        80.0
      ],
      [
        436.66668701171875,
        1520.0,
        80.0
      ],
      [
        434.15838623046875,
        1520.0,
        83.76245880126953
      ],
      [
        434.15838623046875,
        1520.0,
        95.0
      ],
      [
        440.65679931640625,
        1500.0,
        95.0
      ],
      [
        440.65679931640625,
        1500.0,
        80.0
      ],
      [
        436.6667175292969,
        1600.0,
        80.0
      ],
      [
        426.66668701171875,
        1600.0,
        95.0
      ],
      [
        420.0,
        1563.574951171875,
        95.0
      ],
      [
        420.0,
        1563.574951171875,
        80.0
      ],
      [
        420.0,
        1563.574951171875,
        95.0
      ],
      [
        420.0,
        1563.574951171875,
        105.0
      ],
      [
        434.15838623046875,
        1520.0,
        80.0
      ],
      [
        408.1647644042969,
        1600.0,
        105.0
      ],
      [
        411.0671691894531,
        1591.067138671875,
        118.39922332763672
      ],
      [
        408.1647644042969,
        1600.0,
        95.0
      ],
      [
        408.1647644042969,
        1600.0,
        105.0
      ],
      [
        408.1647644042969,
        1600.0,
        80.0
      ],
      [
        408.1647644042969,
        1600.0,
        95.0
      ],
      [
        450.0,
        1471.2445068359375,
        120.0
      ],
      [
        453.653564453125,
        1460.0,
        120.0
      ],
      [
        550.0,
        1460.0,
        120.0
      ],
      [
        550.0,
        1657.302490234375,
        120.0
      ],
      [
        550.0,
        1657.302490234375,
        190.0
      ],
      [
        550.0,
        1589.77294921875,
        190.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        190.0
      ],
      [
        450.0,
        1471.244384765625,
        190.0
      ],
      [
        550.0,
        1460.0,
        140.0
      ],
      [
        453.653564453125,
        1460.0,
        140.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        140.0
      ],
      [
        550.0,
        1589.77294921875,
        140.0
      ],
      [
        550.0,
        1460.0,
        120.0
      ],
      [
        453.653564453125,
        1460.0,
        120.0
      ],
      [
        453.653564453125,
        1460.0,
        140.0
      ],
      [
        550.0,
        1460.0,
        140.0
      ],
      [
        450.0,
        1690.0,
        120.0
      ],
      [
        450.0,
        1690.0,
        140.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        140.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        140.0
      ],
      [
        550.0,
        1657.302490234375,
        140.0
      ],
      [
        550.0,
        1657.302490234375,
        120.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        140.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        150.0
      ],
      [
        550.0,
        1589.77294921875,
        150.0
      ],
      [
        550.0,
        1589.77294921875,
        140.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        190.0
      ],
      [
        550.0,
        1589.77294921875,
        190.0
      ],
      [
        550.0,
        1589.77294921875,
        150.0
      ],
      [
        452.5699157714844,
        1463.3350830078125,
        150.0
      ],
      [
        550.0,
        1657.302490234375,
        190.0
      ],
      [
        505.25732421875,
        1301.1802978515625,
        80.0
      ],
      [
        550.0,
        1657.302490234375,
        80.0
      ],
      [
        550.0,
        869.8679809570312,
        140.0
      ],
      [
        550.0,
        869.8679809570312,
        240.0
      ],
      [
        440.0,
        1380.0,
        210.48057556152344
      ],
      [
        440.0,
        1390.0,
        214.82838439941406
      ],
      [
        440.0,
        1378.8946533203125,
        210.0
      ],
      [
        440.0,
        1380.0,
        210.48057556152344
      ],
      [
        440.0,
        1415.0,
        225.69793701171875
      ],
      [
        440.0,
        1390.0,
        214.82838439941406
      ],
      [
        440.0,
        1310.0,
        180.04576110839844
      ],
      [
        440.0,
        1340.0,
        193.08924865722656
      ],
      [
        440.0,
        1217.8946533203125,
        140.0
      ],
      [
        440.0,
        1171.8946533203125,
        120.0
      ],
      [
        440.0,
        1125.894775390625,
        100.0
      ],
      [
        440.0,
        1171.8946533203125,
        120.0
      ],
      [
        440.0,
        1110.0,
        93.08924865722656
      ],
      [
        440.0,
        1125.894775390625,
        100.0
      ],
      [
        440.0,
        1240.0,
        149.6110076904297
      ],
      [
        440.0,
        1217.8946533203125,
        140.0
      ],
      [
        440.0,
        1121.294677734375,
        98.0
      ],
      [
        447.1913146972656,
        1130.0,
        98.0
      ],
      [
        447.1913146972656,
        1130.0,
        98.0
      ],
      [
        460.0,
        1145.5052490234375,
        98.0
      ],
      [
        440.0,
        1125.894775390625,
        100.0
      ],
      [
        443.3913269042969,
        1130.0,
        100.0
      ],
      [
        460.0,
        1150.105224609375,
        100.0
      ],
      [
        443.3913269042969,
        1130.0,
        100.0
      ],
      [
        460.0,
        1145.5052490234375,
        98.0
      ],
      [
        460.0,
        1150.105224609375,
        100.0
      ],
      [
        450.0,
        1460.0,
        98.0
      ],
      [
        450.0,
        1460.0,
        100.0
      ],
      [
        450.0,
        1471.2445068359375,
        100.0
      ],
      [
        450.0,
        1471.2445068359375,
        98.0
      ],
      [
        440.0,
        1460.0,
        98.0
      ],
      [
        440.0,
        1460.0,
        100.0
      ],
      [
        450.0,
        1460.0,
        100.0
      ],
      [
        450.0,
        1460.0,
        98.0
      ],
      [
        440.0,
        1460.0,
        190.0
      ],
      [
        440.0,
        1460.0,
        240.0
      ],
      [
        440.0,
        1460.0,
        120.0
      ],
      [
        440.0,
        1460.0,
        140.0
      ],
      [
        440.0,
        1460.0,
        120.0
      ],
      [
        440.0,
        1460.0,
        140.0
      ],
      [
        440.0,
        1460.0,
        190.0
      ],
      [
        440.0,
        1460.0,
        245.26315307617188
      ],
      [
        440.0,
        1460.0,
        240.0
      ],
      [
        440.0,
        1495.0,
        140.0
      ],
      [
        440.0,
        1495.0,
        150.0
      ],
      [
        440.0,
        1502.0213623046875,
        140.0
      ],
      [
        440.0,
        1495.0,
        140.0
      ],
      [
        440.0,
        1495.0,
        150.0
      ],
      [
        440.0,
        1502.0213623046875,
        150.0
      ],
      [
        452.5699462890625,
        1463.3349609375,
        120.0
      ],
      [
        440.0,
        1110.0,
        93.0892562866211
      ],
      [
        464.86956787109375,
        1110.0,
        80.0
      ],
      [
        440.0,
        1460.0,
        80.0
      ],
      [
        440.0,
        1500.0,
        95.0
      ],
      [
        440.0,
        1500.0,
        80.0
      ],
      [
        440.0,
        1500.0,
        95.0
      ],
      [
        440.0,
        1502.0213623046875,
        95.0
      ],
      [
        350.0,
        1460.0,
        200.0
      ],
      [
        350.0,
        1460.0,
        190.0
      ],
      [
        350.0,
        1495.0,
        190.0
      ],
      [
        350.0,
        1460.0,
        190.0
      ],
      [
        310.0,
        1460.0,
        190.0
      ],
      [
        350.0,
        1495.0,
        200.0
      ],
      [
        310.0,
        1460.0,
        200.0
      ],
      [
        350.0,
        1460.0,
        200.0
      ],
      [
        350.0,
        1495.0,
        200.0
      ],
      [
        350.0,
        1495.0,
        190.0
      ],
      [
        390.0,
        1510.0,
        150.0
      ],
      [
        396.66668701171875,
        1495.0,
        140.0
      ],
      [
        390.0,
        1510.0,
        150.0
      ],
      [
        396.66668701171875,
        1510.0,
        140.0
      ],
      [
        426.66668701171875,
        1520.0,
        95.0
      ],
      [
        426.66668701171875,
        1510.0,
        95.0
      ],
      [
        437.4075927734375,
        1510.0,
        95.0
      ],
      [
        426.66668701171875,
        1520.0,
        95.0
      ],
      [
        434.15838623046875,
        1520.0,
        83.76245880126953
      ],
      [
        396.66668701171875,
        1510.0,
        140.0
      ],
      [
        396.66668701171875,
        1495.0,
        140.0
      ],
      [
        426.66668701171875,
        1500.0,
        95.0
      ],
      [
        436.6667175292969,
        1500.0,
        80.0
      ],
      [
        426.66668701171875,
        1500.0,
        95.0
      ],
      [
        390.0,
        1510.0,
        140.0
      ],
      [
        390.0,
        1510.0,
        140.0
      ],
      [
        390.0,
        1522.0,
        125.0
      ],
      [
        390.0,
        1578.0,
        125.0
      ],
      [
        390.0,
        1500.0,
        95.0
      ],
      [
        390.0,
        1500.0,
        105.0
      ],
      [
        390.0,
        1500.0,
        105.0
      ],
      [
        390.0,
        1510.0,
        120.0
      ],
      [
        390.0,
        1600.0,
        105.0
      ],
      [
        390.0,
        1590.0,
        120.0
      ],
      [
        390.0,
        1600.0,
        95.0
      ],
      [
        390.0,
        1600.0,
        105.0
      ],
      [
        390.0,
        1600.0,
        80.0
      ],
      [
        390.0,
        1600.0,
        95.0
      ],
      [
        390.0,
        1510.0,
        120.0
      ],
      [
        390.0,
        1522.0,
        125.0
      ],
      [
        390.0,
        1590.0,
        120.0
      ],
      [
        390.0,
        1578.0,
        125.0
      ],
      [
        380.0,
        1495.0,
        200.0
      ],
      [
        380.0,
        1676.076171875,
        240.0
      ],
      [
        380.0,
        1686.68212890625,
        240.0
      ],
      [
        380.0,
        1495.0,
        190.0
      ],
      [
        380.0,
        1495.0,
        200.0
      ],
      [
        380.0,
        1495.0,
        190.0
      ],
      [
        380.0,
        1522.0,
        125.0
      ],
      [
        380.0,
        1578.0,
        125.0
      ],
      [
        380.0,
        1500.0,
        95.0
      ],
      [
        380.0,
        1500.0,
        105.0
      ],
      [
        380.0,
        1600.0,
        95.0
      ],
      [
        380.0,
        1600.0,
        105.0
      ],
      [
        380.0,
        1600.0,
        80.0
      ],
      [
        380.0,
        1600.0,
        95.0
      ],
      [
        380.0,
        1500.0,
        105.0
      ],
      [
        380.0,
        1510.0,
        120.0
      ],
      [
        380.0,
        1600.0,
        105.0
      ],
      [
        380.0,
        1590.0,
        120.0
      ],
      [
        380.0,
        1510.0,
        120.0
      ],
      [
        380.0,
        1522.0,
        125.0
      ],
      [
        380.0,
        1590.0,
        120.0
      ],
      [
        380.0,
        1578.0,
        125.0
      ],
      [
        380.0,
        1470.0,
        125.0
      ],
      [
        390.0,
        1470.0,
        125.0
      ],
      [
        326.08697509765625,
        1310.0,
        240.0
      ],
      [
        440.0,
        1310.0,
        180.04576110839844
      ],
      [
        440.0,
        1415.0,
        225.69793701171875
      ],
      [
        412.8260803222656,
        1415.0,
        240.0
      ],
      [
        440.0,
        1340.0,
        193.08924865722656
      ],
      [
        426.86956787109375,
        1340.0,
        200.0
      ],
      [
        400.0,
        1340.0,
        140.0
      ],
      [
        440.0,
        1340.0,
        180.0
      ],
      [
        440.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        100.0
      ],
      [
        400.0,
        1340.0,
        140.0
      ],
      [
        440.0,
        1378.8946533203125,
        210.0
      ],
      [
        416.13043212890625,
        1350.0,
        210.0
      ],
      [
        310.0,
        1415.0,
        200.0
      ],
      [
        350.0,
        1415.0,
        200.0
      ],
      [
        350.0,
        1415.0,
        190.0
      ],
      [
        350.0,
        1399.9998779296875,
        190.0
      ],
      [
        310.0,
        1399.9998779296875,
        190.0
      ],
      [
        310.0,
        1415.0,
        190.0
      ],
      [
        440.0,
        1410.0,
        180.0
      ],
      [
        435.0,
        1415.0,
        175.0
      ],
      [
        350.0,
        1415.0,
        200.0
      ],
      [
        350.0,
        1399.9998779296875,
        190.0
      ],
      [
        350.0,
        1415.0,
        190.0
      ],
      [
        426.86956787109375,
        1340.0,
        200.0
      ],
      [
        416.13043212890625,
        1350.0,
        210.0
      ],
      [
        440.0,
        1240.0,
        149.6110076904297
      ],
      [
        363.2608947753906,
        1240.0,
        190.0
      ],
      [
        363.26092529296875,
        1240.0,
        190.0
      ],
      [
        310.0,
        1240.0,
        218.0320587158203
      ],
      [
        490.0,
        980.0,
        190.0
      ],
      [
        490.0,
        1110.0,
        190.0
      ],
      [
        490.0,
        1090.0,
        160.0
      ],
      [
        490.0,
        1090.0,
        120.0
      ],
      [
        490.0,
        1110.0,
        160.0
      ],
      [
        490.0,
        1110.0,
        190.0
      ],
      [
        490.0,
        1110.0,
        80.0
      ],
      [
        490.0,
        1110.0,
        120.0
      ],
      [
        490.0,
        1090.0,
        120.0
      ],
      [
        490.0,
        1094.0,
        120.0
      ],
      [
        490.0,
        1090.0,
        120.0
      ],
      [
        490.0,
        1110.0,
        120.0
      ],
      [
        490.0,
        1110.0,
        160.0
      ],
      [
        490.0,
        1090.0,
        160.0
      ],
      [
        447.00006103515625,
        1110.0,
        100.0
      ],
      [
        447.00006103515625,
        1120.0,
        100.0
      ],
      [
        447.00006103515625,
        1130.0,
        100.0
      ],
      [
        451.5000305175781,
        1120.0,
        99.00001525878906
      ],
      [
        451.5000305175781,
        1130.0,
        99.00001525878906
      ],
      [
        483.0,
        1110.0,
        120.0
      ],
      [
        483.0,
        1130.0,
        120.0
      ],
      [
        550.0,
        980.0,
        190.0
      ],
      [
        550.0,
        1110.0,
        190.0
      ],
      [
        550.0,
        1110.0,
        160.0
      ],
      [
        550.0,
        1110.0,
        190.0
      ],
      [
        550.0,
        1110.0,
        80.0
      ],
      [
        550.0,
        1110.0,
        120.0
      ],
      [
        550.0,
        1090.0,
        160.0
      ],
      [
        550.0,
        1090.0,
        120.0
      ],
      [
        550.0,
        1090.0,
        120.0
      ],
      [
        550.0,
        1094.0,
        120.0
      ],
      [
        550.0,
        1090.0,
        120.0
      ],
      [
        550.0,
        1110.0,
        120.0
      ],
      [
        550.0,
        1110.0,
        160.0
      ],
      [
        550.0,
        1090.0,
        160.0
      ],
      [
        602.2073974609375,
        7369.99560546875,
        976.300048828125
      ],
      [
        602.2073974609375,
        6140.26513671875,
        296.60736083984375
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        140.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        160.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        520.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        550.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        100.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        140.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        160.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        520.0
      ],
      [
        596.47607421875,
        1394.3714599609375,
        80.0
      ],
      [
        602.2073974609375,
        1394.3714599609375,
        80.0
      ],
      [
        602.2073974609375,
        1384.3714599609375,
        100.0
      ],
      [
        602.2073974609375,
        1460.0,
        120.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        120.0
      ],
      [
        602.2073974609375,
        1505.5,
        140.0
      ],
      [
        602.2073974609375,
        1495.5,
        140.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        140.0
      ],
      [
        602.2073974609375,
        1460.0,
        140.0
      ],
      [
        602.2073974609375,
        1460.0,
        120.0
      ],
      [
        602.2073974609375,
        1460.0,
        140.0
      ],
      [
        550.0,
        1657.302490234375,
        120.0
      ],
      [
        550.0,
        1657.302490234375,
        140.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        140.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        140.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        140.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        120.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        190.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        80.0
      ],
      [
        602.2073974609375,
        980.0,
        190.0
      ],
      [
        602.2073974609375,
        1110.0,
        190.0
      ],
      [
        600.1320190429688,
        920.0,
        190.0
      ],
      [
        550.0,
        869.8679809570312,
        190.0
      ],
      [
        600.1320190429688,
        920.0,
        190.0
      ],
      [
        602.2073974609375,
        920.0,
        160.0
      ],
      [
        602.2073974609375,
        920.0,
        190.0
      ],
      [
        602.2073974609375,
        1110.0,
        160.0
      ],
      [
        602.2073974609375,
        1110.0,
        190.0
      ],
      [
        602.2073974609375,
        1110.0,
        80.0
      ],
      [
        602.2073974609375,
        1110.0,
        120.0
      ],
      [
        602.2073974609375,
        1090.0,
        160.0
      ],
      [
        602.2073974609375,
        1090.0,
        120.0
      ],
      [
        602.2073974609375,
        1090.0,
        120.0
      ],
      [
        602.2073974609375,
        1094.0,
        120.0
      ],
      [
        602.2073974609375,
        1090.0,
        120.0
      ],
      [
        602.2073974609375,
        1110.0,
        120.0
      ],
      [
        602.2073974609375,
        1110.0,
        160.0
      ],
      [
        602.2073974609375,
        1090.0,
        160.0
      ],
      [
        602.2073974609375,
        920.0,
        240.0
      ],
      [
        310.0,
        261.3146057128906,
        60.0
      ],
      [
        310.0,
        261.3146057128906,
        420.0
      ],
      [
        650.0,
        5409.76806640625,
        80.0
      ],
      [
        602.2073974609375,
        5411.8876953125,
        80.0
      ],
      [
        650.0,
        7360.4892578125,
        80.0
      ],
      [
        602.2073974609375,
        7369.99560546875,
        80.0
      ],
      [
        650.0,
        1384.3714599609375,
        96.81153869628906
      ],
      [
        647.95654296875,
        1460.0,
        80.0
      ],
      [
        647.95654296875,
        1460.0,
        190.0
      ],
      [
        647.95654296875,
        1460.0,
        190.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        120.0
      ],
      [
        602.2073974609375,
        1607.625244140625,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        120.0
      ],
      [
        640.0,
        1500.0,
        120.0
      ],
      [
        640.0,
        1500.0,
        140.0
      ],
      [
        640.0,
        1460.0,
        140.0
      ],
      [
        640.0,
        1460.0,
        120.0
      ],
      [
        640.0,
        1460.0,
        120.0
      ],
      [
        640.0,
        1460.0,
        140.0
      ],
      [
        647.95654296875,
        1460.0,
        140.0
      ],
      [
        647.95654296875,
        1460.0,
        120.0
      ],
      [
        640.0,
        1394.3714599609375,
        80.0
      ],
      [
        640.0,
        1384.3714599609375,
        100.0
      ],
      [
        602.2073974609375,
        920.0,
        190.0
      ],
      [
        650.0,
        920.0,
        190.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -3700.0,
        -500.0
      ],
      "bbox_max": [
        7986.5068359375,
        7450.0,
        2700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4714.04296875,
        -2619.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -4714.04296875,
        -2619.10009765625,
        1314.8355712890625
      ],
      "bbox_max": [
        -4205.2001953125,
        -1600.0,
        1446.2291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -3802.89990234375,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        -1600.0,
        151.26788330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -3802.89990234375,
        -2269.10009765625,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        -1600.0,
        151.26788330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.0238037109375,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6544189453125,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        5535.3330078125,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        793.1160278320312
      ],
      "bbox_max": [
        2400.0,
        -2007.71044921875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2378.125,
        793.1160278320312
      ],
      "bbox_max": [
        2400.0,
        -2007.71044921875,
        1284.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        752.41064453125
      ],
      "bbox_max": [
        7600.0,
        -1600.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        752.41064453125
      ],
      "bbox_max": [
        5742.857421875,
        -1600.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        252.5999755859375
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -1600.000244140625,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        4995.78271484375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -6971.595703125,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        -3400.0,
        4995.78271484375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -6971.595703125,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        -3578.668701171875,
        4995.78271484375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.213623046875,
      "bbox_min": [
        -6971.595703125,
        2154.178466796875,
        150.0
      ],
      "bbox_max": [
        -4912.15185546875,
        4995.78271484375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        2940.080810546875,
        1150.1849365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        0.0
      ],
      "bbox_max": [
        -3400.0,
        2940.080810546875,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -1600.0,
        336.2261657714844
      ],
      "bbox_max": [
        -3400.0,
        2993.050048828125,
        1251.2120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        2154.178466796875,
        336.2261657714844
      ],
      "bbox_max": [
        -3400.0,
        2993.050048828125,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5121459960938,
      "bbox_min": [
        3956.501220703125,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        3956.501220703125,
        2270.430419921875,
        -300.0
      ],
      "bbox_max": [
        6811.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        3988.998046875,
        2270.430419921875,
        -300.0
      ],
      "bbox_max": [
        6166.06201171875,
        5971.7080078125,
        1783.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        4104.1787109375,
        4116.14306640625,
        -300.0
      ],
      "bbox_max": [
        4237.6171875,
        4205.02490234375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        4117.16162109375,
        2270.430419921875,
        1016.0430908203125
      ],
      "bbox_max": [
        4137.6171875,
        2301.583251953125,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3988.998046875,
        3098.861328125,
        -300.0
      ],
      "bbox_max": [
        6166.06201171875,
        5971.7080078125,
        1783.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3988.998046875,
        3098.861328125,
        0.0
      ],
      "bbox_max": [
        6113.75048828125,
        5971.7080078125,
        1755.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3988.998046875,
        5037.267578125,
        101.19913482666016
      ],
      "bbox_max": [
        4447.9970703125,
        5971.7080078125,
        939.7494506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        4059.008056640625,
        3098.861328125,
        0.0
      ],
      "bbox_max": [
        4237.6171875,
        4116.14306640625,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4087.392822265625,
        3098.861328125,
        933.0609741210938
      ],
      "bbox_max": [
        4157.6171875,
        3154.043701171875,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        3956.501220703125,
        3150.14306640625,
        711.0925903320312
      ],
      "bbox_max": [
        6811.5068359375,
        6902.2900390625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        3981.694580078125,
        3150.14306640625,
        711.0925903320312
      ],
      "bbox_max": [
        6306.5068359375,
        6180.85302734375,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3981.694580078125,
        5070.96826171875,
        711.0925903320312
      ],
      "bbox_max": [
        6306.5068359375,
        6180.85302734375,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3981.694580078125,
        5744.82666015625,
        711.0925903320312
      ],
      "bbox_max": [
        4529.33349609375,
        6180.85302734375,
        1099.716064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        6113.75048828125,
        5070.96826171875,
        1755.698974609375
      ],
      "bbox_max": [
        6306.5068359375,
        5140.50634765625,
        1913.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3956.501220703125,
        5140.50634765625,
        847.5980224609375
      ],
      "bbox_max": [
        6306.5068359375,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.501220703125,
        5879.8046875,
        847.5980224609375
      ],
      "bbox_max": [
        4964.0634765625,
        6902.2900390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        4252.54541015625,
        -1600.0,
        538.225830078125
      ],
      "bbox_max": [
        7600.0,
        -1350.0,
        852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        5742.85693359375,
        -1600.0,
        602.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1350.0,
        852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2504.6513671875,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        4253.40771484375,
        7187.068359375,
        1318.467529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2511.526123046875,
        4439.76806640625,
        -300.0
      ],
      "bbox_max": [
        4029.05859375,
        6990.208984375,
        589.12548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4947.1650390625,
        0.0
      ],
      "bbox_max": [
        4024.77587890625,
        4956.259765625,
        44.461669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3671.12890625,
        4858.1806640625,
        -300.0
      ],
      "bbox_max": [
        3970.173828125,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        2504.6513671875,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        4253.40771484375,
        7187.068359375,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2504.6513671875,
        4392.6396484375,
        -300.0
      ],
      "bbox_max": [
        4044.14013671875,
        7187.068359375,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2511.52587890625,
        6871.484375,
        171.574462890625
      ],
      "bbox_max": [
        3108.39404296875,
        6990.208984375,
        630.7308959960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        2511.52587890625,
        5027.466796875,
        -27.623554229736328
      ],
      "bbox_max": [
        3045.157470703125,
        6990.208984375,
        642.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2579.9189453125,
        5027.466796875,
        -27.623554229736328
      ],
      "bbox_max": [
        3045.157470703125,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2511.52587890625,
        6889.4033203125,
        624.2333374023438
      ],
      "bbox_max": [
        3018.309814453125,
        6990.208984375,
        642.9444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        2511.52587890625,
        -1600.0,
        -106.37001037597656
      ],
      "bbox_max": [
        4253.40771484375,
        6990.208984375,
        1019.3637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6274019479751587,
        0.7507457733154297,
        0.20675456523895264
      ],
      "plane_d": -431.48779296875,
      "bbox_min": [
        2780.0,
        -1600.0,
        -106.37001037597656
      ],
      "bbox_max": [
        4253.40771484375,
        5066.6083984375,
        580.4847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        -1600.0,
        129.53280639648438
      ],
      "bbox_max": [
        4253.40771484375,
        2051.5556640625,
        580.4847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        3885.714111328125,
        -1600.0,
        531.17138671875
      ],
      "bbox_max": [
        4253.40771484375,
        -1575.3094482421875,
        580.4847412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        2948.912841796875,
        4630.34521484375,
        -106.37001037597656
      ],
      "bbox_max": [
        4035.83935546875,
        5066.6083984375,
        42.3914680480957
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4760.92822265625,
        0.0
      ],
      "bbox_max": [
        4031.279296875,
        4951.876953125,
        42.3914680480957
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2948.912841796875,
        5033.93603515625,
        -3.095168113708496
      ],
      "bbox_max": [
        3045.157470703125,
        5066.6083984375,
        8.551486015319824
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        2951.9765625,
        5034.5224609375,
        -1.1007986068725586
      ],
      "bbox_max": [
        3045.157470703125,
        5066.6083984375,
        8.551486015319824
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2511.52587890625,
        1830.0,
        -14.961797714233398
      ],
      "bbox_max": [
        4117.16162109375,
        6990.208984375,
        1016.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        1830.0,
        -4.590198516845703
      ],
      "bbox_max": [
        3240.0,
        5080.740234375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2902.4248046875,
        5033.65283203125,
        -4.590198516845703
      ],
      "bbox_max": [
        2951.743896484375,
        5034.55810546875,
        -1.2249693870544434
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2907.179931640625,
        5034.54638671875,
        -1.8093819618225098
      ],
      "bbox_max": [
        2953.59814453125,
        5035.14697265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2511.52587890625,
        2301.5830078125,
        -14.961797714233398
      ],
      "bbox_max": [
        4117.16162109375,
        6990.208984375,
        1016.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        2511.52587890625,
        5031.68798828125,
        -14.961797714233398
      ],
      "bbox_max": [
        3108.39404296875,
        6990.208984375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2579.81591796875,
        5031.68798828125,
        -14.961797714233398
      ],
      "bbox_max": [
        2907.179931640625,
        5034.6416015625,
        -1.8093819618225098
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        2579.744873046875,
        5034.55810546875,
        -6.102384567260742
      ],
      "bbox_max": [
        2910.27392578125,
        5036.67626953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2720.0,
        1330.0,
        -300.0
      ],
      "bbox_max": [
        2583.237548828125,
        7450.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -2720.0,
        1330.0,
        -300.0
      ],
      "bbox_max": [
        2583.237548828125,
        7450.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        -217.4042510986328,
        4949.07666015625,
        -300.0
      ],
      "bbox_max": [
        2579.744873046875,
        7250.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -2720.0,
        1330.0,
        -300.0
      ],
      "bbox_max": [
        -99.99644470214844,
        5069.6220703125,
        60.000003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2720.0,
        1330.0,
        -300.0
      ],
      "bbox_max": [
        -99.99644470214844,
        5069.6220703125,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        1330.0,
        -300.0
      ],
      "bbox_max": [
        -99.99644470214844,
        5069.6220703125,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -1840.0,
        1750.0,
        -300.0
      ],
      "bbox_max": [
        -99.99644470214844,
        5069.6220703125,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1800.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -3400.0,
        1330.0,
        60.0
      ],
      "bbox_max": [
        -414.794677734375,
        7327.7099609375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2720.0,
        1330.0,
        60.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -2710.0,
        1330.0,
        60.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2710.0,
        1330.0,
        185.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -1900.0,
        1330.0,
        185.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1900.0,
        1330.0,
        185.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1900.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1851.7857666015625,
        1750.0,
        199.99978637695312
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1850.0,
        1750.0,
        60.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1850.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1840.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1820.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1750.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1905.0,
        1470.0,
        60.0
      ],
      "bbox_max": [
        2572.041748046875,
        7190.8154296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        1905.0,
        1470.0,
        60.0
      ],
      "bbox_max": [
        2572.041748046875,
        7190.8154296875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        1905.0,
        6990.208984375,
        60.0
      ],
      "bbox_max": [
        2511.526123046875,
        7110.8544921875,
        638.50732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        1905.0,
        1470.0,
        60.0
      ],
      "bbox_max": [
        2572.041748046875,
        7110.8544921875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        1905.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2511.52587890625,
        7110.8544921875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1905.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1905.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1905.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1905.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1905.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1905.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1905.0,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1973.3603515625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1909.74462890625,
        1895.74462890625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1905.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1975.4896240234375,
        1900.489501953125,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1759.9998779296875,
        1059.6484375
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1760.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1150.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9659257531166077,
        -0.258819580078125,
        -0.0
      ],
      "plane_d": 2319.75927734375,
      "bbox_min": [
        1917.9423828125,
        1760.0001220703125,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1805.0001220703125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1910.0,
        1760.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1812.9427490234375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1923.157958984375,
        1793.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1910.0,
        1768.0384521484375,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1812.9427490234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1910.0,
        1768.0384521484375,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1910.0,
        1789.474365234375,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1905.0,
        1760.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1905.0,
        1812.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1905.0,
        1812.9425048828125,
        1130.0
      ],
      "bbox_max": [
        1910.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1905.0,
        1760.0001220703125,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1817.9425048828125,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1905.0,
        1766.69873046875,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1789.474365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1905.0,
        1788.1346435546875,
        1110.0
      ],
      "bbox_max": [
        1910.0,
        1789.474365234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        1210.0,
        1220.0,
        60.0
      ],
      "bbox_max": [
        1905.0,
        7249.0986328125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        1210.0,
        7110.8544921875,
        60.0
      ],
      "bbox_max": [
        1905.0,
        7249.0986328125,
        634.3726806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        1210.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1905.0,
        7249.0986328125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        1210.0,
        7110.8544921875,
        602.4280395507812
      ],
      "bbox_max": [
        1905.0,
        7249.0986328125,
        647.4180297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        1210.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1905.0,
        7249.0986328125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1210.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1905.0,
        2050.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1905.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1905.0,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1905.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1550.0,
        1654.800048828125,
        370.0
      ],
      "bbox_max": [
        1905.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.045654296875,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1905.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1814.6104736328125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1704.5103759765625,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1905.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1852.5001220703125,
        1832.5833740234375,
        1110.0
      ],
      "bbox_max": [
        1905.0,
        1867.4169921875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1852.5001220703125,
        1846.6507568359375,
        1110.0
      ],
      "bbox_max": [
        1853.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1840.0001220703125,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1905.0,
        1850.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1905.0,
        1837.9423828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1846.6507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6480712890625
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1115.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1840.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1840.0,
        1800.0,
        1110.0
      ],
      "bbox_max": [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1892.9425048828125,
        1817.9425048828125,
        1060.0
      ],
      "bbox_max": [
        1905.0,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.045654296875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1210.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1250.0,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        1250.0,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1250.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1210.0,
        1610.0,
        259.0909118652344
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1210.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1250.0,
        1630.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1210.0,
        1610.0,
        259.0909118652344
      ],
      "bbox_max": [
        1225.0,
        1610.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        650.0,
        1252.98779296875,
        60.0
      ],
      "bbox_max": [
        1210.0,
        7360.4892578125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        650.0,
        7249.0986328125,
        60.0
      ],
      "bbox_max": [
        1210.0,
        7360.4892578125,
        660.1118774414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        650.0,
        1252.98779296875,
        60.0
      ],
      "bbox_max": [
        1210.0,
        7360.4892578125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        650.0,
        1252.98779296875,
        60.0
      ],
      "bbox_max": [
        1210.0,
        7196.82421875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        1030.0,
        1463.6845703125,
        190.0
      ],
      "bbox_max": [
        1210.0,
        7196.28271484375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        1030.0,
        1463.6845703125,
        190.0
      ],
      "bbox_max": [
        1210.0,
        1710.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1463.6845703125,
        370.0852355957031
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1463.6845703125,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        190.0
      ],
      "bbox_max": [
        1210.0,
        1710.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        190.0
      ],
      "bbox_max": [
        1210.0,
        1710.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        303.5163879394531
      ],
      "bbox_max": [
        1210.0,
        1710.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 543.9276733398438,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1210.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1210.0,
        1690.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1210.0,
        1630.0,
        429.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        650.0,
        1252.98779296875,
        60.0
      ],
      "bbox_max": [
        1030.0,
        7196.82421875,
        619.8324584960938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        713.2942504882812,
        1252.98779296875,
        60.0
      ],
      "bbox_max": [
        784.061279296875,
        1336.4150390625,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        740.0,
        1282.04931640625,
        60.0
      ],
      "bbox_max": [
        784.061279296875,
        1317.0123291015625,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        760.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        763.41552734375,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1282.04931640625,
        60.0
      ],
      "bbox_max": [
        784.061279296875,
        1287.95068359375,
        60.4061279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": 742.3746948242188,
      "bbox_min": [
        760.0,
        1267.5185546875,
        105.64138793945312
      ],
      "bbox_max": [
        777.1793212890625,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        760.0,
        1267.5185546875,
        105.64138793945312
      ],
      "bbox_max": [
        777.1793212890625,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        1267.5185546875,
        140.0
      ],
      "bbox_max": [
        777.1793212890625,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        650.0,
        1285.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        7196.82421875,
        619.8324584960938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1690.0,
        216.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1615.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        970.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1845.548828125,
      "bbox_min": [
        780.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 671.7514038085938,
      "bbox_min": [
        780.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1690.0,
        145.0852508544922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        804.9573364257812,
        1655.0,
        144.99996948242188
      ],
      "bbox_max": [
        805.0,
        1655.025634765625,
        145.0852508544922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1690.0,
        145.04261779785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        805.0,
        1690.0,
        145.04261779785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1670.0,
        120.0
      ],
      "bbox_max": [
        800.0,
        1690.0,
        140.08517456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        804.9573974609375,
        1580.0,
        135.00010681152344
      ],
      "bbox_max": [
        955.0,
        1610.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1580.0,
        145.00006103515625
      ],
      "bbox_max": [
        954.0,
        1595.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 671.7514038085938,
      "bbox_min": [
        804.9573974609375,
        1594.9573974609375,
        140.0
      ],
      "bbox_max": [
        810.0,
        1610.0,
        145.0426025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1640.0,
        160.00018310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1640.0,
        130.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        160.00018310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -459.6195068359375,
      "bbox_min": [
        945.0,
        1595.0,
        120.0
      ],
      "bbox_max": [
        955.0,
        1605.0,
        145.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1590.0,
        130.085205078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        790.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        790.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        800.0,
        1580.0,
        140.08517456054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        719.9147338867188,
        1285.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1427.3575439453125,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        719.9147338867188,
        1285.0,
        60.0
      ],
      "bbox_max": [
        1024.9285888671875,
        1570.0,
        180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        737.914794921875,
        1285.0,
        78.0
      ],
      "bbox_max": [
        1024.9285888671875,
        1570.0,
        180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        737.914794921875,
        1287.95068359375,
        78.0
      ],
      "bbox_max": [
        890.0,
        1570.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1311.1109619140625,
        78.0
      ],
      "bbox_max": [
        890.0,
        1540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        820.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        827.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        737.914794921875,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        740.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        760.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        763.41552734375,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        737.914794921875,
        1420.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        1024.9285888671875,
        1570.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        1024.9285888671875,
        1570.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1540.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        883.0,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 890.0,
      "bbox_min": [
        883.0,
        1400.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        883.0,
        1440.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1540.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1440.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        820.0,
        1440.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1440.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        80.0
      ],
      "bbox_max": [
        882.9999389648438,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1570.0,
        160.08518981933594
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        890.0,
        1570.0,
        160.08518981933594
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        890.0,
        1570.0,
        160.08518981933594
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        160.08518981933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        799.914794921875,
        1400.0,
        140.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        155.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1434.0,
      "bbox_min": [
        831.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1416.0,
      "bbox_min": [
        831.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        850.0,
        1416.0,
        140.0
      ],
      "bbox_max": [
        850.0,
        1434.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1540.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1400.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        719.9147338867188,
        1310.0,
        60.0
      ],
      "bbox_max": [
        890.0,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        719.9147338867188,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1540.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        780.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        719.9147338867188,
        1400.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1453.3616943359375,
        70.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        719.914794921875,
        1450.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1453.3616943359375,
        66.72349548339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        650.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        7196.82421875,
        619.8324584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        700.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        720.0,
        1310.0,
        60.085205078125
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        720.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        120.08523559570312
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 671.7514038085938,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        795.0,
        1472.8121337890625,
        145.0426025390625
      ],
      "bbox_max": [
        859.914794921875,
        1690.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        795.0,
        1540.0,
        145.0426025390625
      ],
      "bbox_max": [
        839.914794921875,
        1690.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        795.0,
        1685.0,
        149.99996948242188
      ],
      "bbox_max": [
        800.0,
        1690.0,
        160.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        800.0,
        1590.0,
        145.0426025390625
      ],
      "bbox_max": [
        809.914794921875,
        1594.9573974609375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        795.0,
        1540.0,
        149.99996948242188
      ],
      "bbox_max": [
        820.0,
        1575.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        795.0,
        1570.0,
        149.99996948242188
      ],
      "bbox_max": [
        800.0,
        1575.0,
        160.0000457763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        820.0,
        1580.0,
        180.0
      ],
      "bbox_max": [
        859.914794921875,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        804.9573364257812,
        1690.0,
        155.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1570.0,
        140.0
      ],
      "bbox_max": [
        804.9573364257812,
        1690.0,
        155.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        790.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        799.9999389648438,
        1580.0,
        154.99998474121094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1689.914794921875,
        140.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1658.0511474609375,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1689.914794921875,
        140.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1658.0511474609375,
        120.08523559570312
      ],
      "bbox_max": [
        799.9147338867188,
        1670.0,
        140.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        780.0,
        1400.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1450.0,
        120.08523559570312
      ],
      "bbox_max": [
        799.914794921875,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1400.0,
        60.085205078125
      ],
      "bbox_max": [
        730.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        720.0,
        1400.0,
        60.08526611328125
      ],
      "bbox_max": [
        730.0,
        1400.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        700.0,
        1400.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        718.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        718.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        718.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        650.0,
        1331.5430908203125,
        60.0
      ],
      "bbox_max": [
        1030.0,
        7196.82421875,
        619.8324584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        650.0,
        1460.0,
        140.00001525878906
      ],
      "bbox_max": [
        1030.0,
        7196.82421875,
        619.8324584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        650.0,
        1460.0,
        140.00001525878906
      ],
      "bbox_max": [
        840.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        790.0,
        1570.0,
        150.0
      ],
      "bbox_max": [
        840.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        790.0,
        1655.0,
        150.00001525878906
      ],
      "bbox_max": [
        805.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        790.0,
        1655.0,
        150.00001525878906
      ],
      "bbox_max": [
        805.0,
        1664.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        790.0,
        1570.0,
        150.00003051757812
      ],
      "bbox_max": [
        800.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        650.0,
        1460.0,
        140.00001525878906
      ],
      "bbox_max": [
        790.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        1460.0,
        140.00001525878906
      ],
      "bbox_max": [
        790.0,
        1680.0,
        216.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        140.00001525878906
      ],
      "bbox_max": [
        790.0,
        1680.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1664.0,
        140.00001525878906
      ],
      "bbox_max": [
        790.0,
        1680.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1664.0,
        140.00001525878906
      ],
      "bbox_max": [
        790.0,
        1670.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        190.0
      ],
      "bbox_max": [
        790.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -629.3250732421875,
      "bbox_min": [
        780.0,
        1664.0,
        190.0
      ],
      "bbox_max": [
        790.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1664.0,
        190.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        650.0,
        1331.5430908203125,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        650.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        650.0,
        1400.0,
        60.0
      ],
      "bbox_max": [
        718.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        650.0,
        1400.0,
        60.0
      ],
      "bbox_max": [
        718.0,
        1400.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        650.0,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        650.0,
        1392.718994140625,
        80.0
      ],
      "bbox_max": [
        650.5369262695312,
        1394.3714599609375,
        83.30496978759766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1024.9285888671875,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1030.0,
        1460.0,
        370.085205078125
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        1038.692626953125,
        1470.0,
        378.7778015136719
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1038.692626953125,
        1470.0,
        378.7778015136719
      ],
      "bbox_max": [
        1075.0,
        1496.3787841796875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1038.692626953125,
        1470.0,
        378.7778015136719
      ],
      "bbox_max": [
        1050.0,
        1478.21533203125,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1460.0,
        370.085205078125
      ],
      "bbox_max": [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1024.9285888671875,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1463.6845703125,
        370.085205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1030.0,
        970.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        970.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1380.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1075.0,
        1068.85791015625,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1154.050048828125,
        1087.050048828125,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1075.0,
        1085.4320068359375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1152.4320068359375,
        1085.4320068359375,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1075.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1075.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        970.0,
        120.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1030.0,
        975.9603881835938,
        120.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        806.125732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1074.050048828125,
        796.2268676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1042.949951171875,
        975.9603881835938,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        796.2144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1030.0,
        1093.0,
        120.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        806.125732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1030.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        1075.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        970.0,
        580.0
      ],
      "bbox_max": [
        1044.914306640625,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        970.0,
        580.0
      ],
      "bbox_max": [
        1044.914306640625,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1044.5675048828125,
        977.5806884765625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1380.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1390.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        735.6065673828125,
        970.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        765.58935546875,
        970.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1184.0430908203125,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        783.0528564453125,
        970.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1184.0430908203125,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        783.0528564453125,
        970.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1121.3931884765625,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        861.3306884765625,
        970.0,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        861.3306884765625,
        1120.0,
        60.0
      ],
      "bbox_max": [
        868.6693115234375,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        783.0528564453125,
        970.0,
        110.0
      ],
      "bbox_max": [
        1020.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1066.3372802734375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        783.0528564453125,
        970.0,
        110.0
      ],
      "bbox_max": [
        946.9471435546875,
        1110.6966552734375,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        783.0528564453125,
        970.0,
        110.0
      ],
      "bbox_max": [
        946.9471435546875,
        1100.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        794.0264282226562,
        970.0,
        110.0
      ],
      "bbox_max": [
        946.9471435546875,
        1100.0001220703125,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        805.0,
        970.0,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1100.0001220703125,
        170.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        794.0264282226562,
        980.2852783203125,
        170.0
      ],
      "bbox_max": [
        834.2426147460938,
        1045.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        1020.7152099609375,
        170.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        865.0,
        1073.831787109375,
        170.0
      ],
      "bbox_max": [
        933.9188842773438,
        1110.6966552734375,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        796.0811157226562,
        1073.831787109375,
        170.0
      ],
      "bbox_max": [
        893.17138671875,
        1121.3931884765625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        868.6693115234375,
        1058.743408203125,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1184.0430908203125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1017.9999389648438,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1184.0430908203125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        1066.33740234375,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        1062.5404052734375,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        1077.7281494140625,
        118.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        887.6677856445312,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1017.9999389648438,
        1179.4866943359375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        765.58935546875,
        1045.0001220703125,
        60.0
      ],
      "bbox_max": [
        807.7501220703125,
        1099.6556396484375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        1045.0001220703125,
        110.0
      ],
      "bbox_max": [
        807.7501220703125,
        1099.6556396484375,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        765.58935546875,
        1051.75634765625,
        108.0
      ],
      "bbox_max": [
        780.0,
        1089.1190185546875,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        765.58935546875,
        1051.75634765625,
        108.0
      ],
      "bbox_max": [
        780.0,
        1089.1190185546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 466.6302185058594,
      "bbox_min": [
        735.6065673828125,
        1083.6473388671875,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        737.9147338867188,
        1084.5302734375,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        370.0852355957031
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        737.9147338867188,
        1084.5302734375,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        113.39020538330078
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        739.9147338867188,
        1084.5302734375,
        60.0
      ],
      "bbox_max": [
        900.0,
        1150.0,
        110.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        1089.1190185546875,
        60.0
      ],
      "bbox_max": [
        861.3306884765625,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1089.1190185546875,
        60.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        767.9147338867188,
        1084.5302734375,
        80.0
      ],
      "bbox_max": [
        861.3306884765625,
        1130.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        767.9147338867188,
        1084.5302734375,
        80.0
      ],
      "bbox_max": [
        861.3306884765625,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        767.9147338867188,
        1084.5302734375,
        80.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        767.9147338867188,
        1084.5302734375,
        108.0
      ],
      "bbox_max": [
        780.0,
        1120.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        767.9147338867188,
        1120.0,
        108.0
      ],
      "bbox_max": [
        845.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        767.9147338867188,
        1120.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1126.0426025390625,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        740.0,
        1150.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        113.39020538330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": 742.3746948242188,
      "bbox_min": [
        740.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        113.39020538330078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1252.98779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        805.3590087890625,
        1190.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        250.08526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -1521.5843505859375,
      "bbox_min": [
        805.3590087890625,
        1212.0,
        140.0
      ],
      "bbox_max": [
        874.6409912109375,
        1272.0,
        214.72625732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -681.5838623046875,
      "bbox_min": [
        805.3590087890625,
        1212.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1272.0,
        180.08523559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        805.3590087890625,
        1212.0,
        140.0
      ],
      "bbox_max": [
        805.3590087890625,
        1252.0,
        145.4442596435547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -533.9730834960938,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1360.0,
        83.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1358.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98627471923828,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        64.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        807.4441528320312,
        1280.0,
        64.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        945.5584716796875,
        1300.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1386.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -533.9730834960938,
      "bbox_min": [
        807.4441528320312,
        1280.0,
        64.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        807.4441528320312,
        1280.0,
        64.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        807.4441528320312,
        1280.0,
        64.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        64.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        78.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        78.0
      ],
      "bbox_max": [
        945.5585327148438,
        1390.0,
        160.08522033691406
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        820.0,
        1310.0,
        160.08522033691406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        78.0
      ],
      "bbox_max": [
        945.5585327148438,
        1390.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        777.1793212890625,
        1280.0,
        78.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        807.4441528320312,
        1301.9886474609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1282.04931640625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        735.6065673828125,
        1083.6473388671875,
        78.0
      ],
      "bbox_max": [
        1030.0,
        1311.1109619140625,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -681.5838623046875,
      "bbox_min": [
        805.3590087890625,
        1190.0,
        145.4442596435547
      ],
      "bbox_max": [
        1030.0,
        1311.1109619140625,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        840.0,
        1190.0,
        180.08523559570312
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        840.0,
        1190.0,
        180.08523559570312
      ],
      "bbox_max": [
        910.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -1521.5843505859375,
      "bbox_min": [
        840.0,
        1212.0,
        180.08523559570312
      ],
      "bbox_max": [
        910.0,
        1272.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        874.6409912109375,
        1212.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1252.0,
      "bbox_min": [
        874.6409912109375,
        1252.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        818.4708862304688,
        1280.0,
        160.08522033691406
      ],
      "bbox_max": [
        839.914794921875,
        1311.1109619140625,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        820.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        839.914794921875,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        818.4708862304688,
        1310.0,
        178.47085571289062
      ],
      "bbox_max": [
        820.0,
        1311.1109619140625,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        735.6065673828125,
        1083.6473388671875,
        78.0
      ],
      "bbox_max": [
        799.9147338867188,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        777.1792602539062,
        1280.0,
        117.26458740234375
      ],
      "bbox_max": [
        799.9147338867188,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        1096.0167236328125,
        108.0
      ],
      "bbox_max": [
        769.9147338867188,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        760.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        769.9147338867188,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        735.6065673828125,
        1140.4658203125,
        78.0
      ],
      "bbox_max": [
        739.9147338867188,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        735.6065673828125,
        1150.0,
        78.0
      ],
      "bbox_max": [
        739.9147338867188,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        816.9432983398438,
        1150.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        740.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        816.9432983398438,
        1140.277099609375,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1051.7562255859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1096.0167236328125,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        760.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1096.0167236328125,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        650.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        650.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        650.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        650.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        650.0,
        1110.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        650.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        928.58154296875,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1139.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        95.71428680419922
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        139.2857208251953
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.293701171875,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.49658203125,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1418.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1090.0,
        1390.0,
        95.71428680419922
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        136.42857360839844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1090.0,
        1390.0,
        95.71428680419922
      ],
      "bbox_max": [
        1140.0,
        1432.0,
        116.42857360839844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.29367065429688,
      "bbox_min": [
        1090.0,
        1418.0,
        100.0
      ],
      "bbox_max": [
        1140.0,
        1432.0,
        114.28571319580078
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1390.0,
        98.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1418.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": -1095.3739013671875,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1418.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1418.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1430.0,
        98.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1460.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        -0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": 1338.8778076171875,
      "bbox_min": [
        1120.0,
        1430.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        -0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": 1322.496826171875,
      "bbox_min": [
        1120.0,
        1432.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        -0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": 1338.877685546875,
      "bbox_min": [
        1090.0,
        1430.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.4967041015625,
      "bbox_min": [
        1090.0,
        1432.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        928.58154296875,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        928.58154296875,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        928.58154296875,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        928.58154296875,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1000.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        928.5816650390625,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.09950380027294159,
        0.0,
        0.9950371384620667
      ],
      "plane_d": 17.910751342773438,
      "bbox_min": [
        928.5816650390625,
        1390.0,
        74.85816955566406
      ],
      "bbox_max": [
        980.0,
        1427.3575439453125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        650.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        650.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        780.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1020.4000244140625,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        1010.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1020.4000244140625,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1020.4000244140625,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        650.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        760.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1024.6068115234375,
        967.1428833007812,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        720.0,
        140.0
      ],
      "bbox_max": [
        1024.6068115234375,
        967.1428833007812,
        245.1685333251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        866.3075561523438,
        720.0,
        140.0
      ],
      "bbox_max": [
        1024.6068115234375,
        950.0,
        245.1685333251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1024.6068115234375,
        950.0,
        245.1685333251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1016.6666870117188,
        950.0,
        140.0
      ],
      "bbox_max": [
        1023.6000366210938,
        967.1428833007812,
        220.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1017.0270385742188,
        967.1428833007812,
        140.54055786132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        861.3309326171875,
        944.6067504882812,
        140.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        861.3309326171875,
        950.0,
        140.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        861.3309326171875,
        957.0,
        140.0
      ],
      "bbox_max": [
        1037.0,
        970.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        861.3309326171875,
        967.0270385742188,
        140.0
      ],
      "bbox_max": [
        1020.0,
        970.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        861.3309326171875,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        868.6690673828125,
        970.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        850.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        1905.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        457.1454162597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        1290.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        1905.0,
        -1277.2857666015625,
        399.28826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        866.3075561523438,
        720.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        866.3075561523438,
        720.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        1210.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        1290.0,
        -1435.4285888671875,
        327.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        840.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        1210.0,
        -1456.0,
        318.05450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        840.0,
        -1551.142822265625,
        274.8077697753906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.948459267616272,
        -0.020618680864572525,
        0.3162277638912201
      ],
      "plane_d": 291.75433349609375,
      "bbox_min": [
        -533.3333129882812,
        540.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        7450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -533.3333129882812,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -167.24493408203125,
        7376.95068359375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -414.794677734375,
        7327.7099609375,
        60.0
      ],
      "bbox_max": [
        -167.24493408203125,
        7376.95068359375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        0.16439898312091827
      ],
      "plane_d": 1380.951416015625,
      "bbox_min": [
        -533.3333129882812,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -296.9612731933594,
        1430.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -533.3333129882812,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1413.3333740234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -300.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        7450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -300.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        7450.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -300.0,
        1077.7781982421875,
        60.0
      ],
      "bbox_max": [
        260.0,
        7450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        -50.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        7450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -50.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -226.04701232910156,
        1077.7781982421875,
        60.0
      ],
      "bbox_max": [
        260.0,
        1413.3333740234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -226.04701232910156,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1239.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996509552002,
        0.7072148323059082
      ],
      "plane_d": 419.9613037109375,
      "bbox_min": [
        -144.5,
        1077.7781982421875,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1158.39990234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        80.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        75.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": 834.8184204101562,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        0.7071000337600708,
        0.0
      ],
      "plane_d": -699.5860595703125,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 1103.51904296875,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1348.347412109375,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1249.999267578125,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1213.117431640625,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1114.7694091796875,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70711350440979,
        0.7071000337600708,
        -5.754504854849074e-06
      ],
      "plane_d": -968.2886962890625,
      "bbox_min": [
        120.0,
        1214.3779296875,
        60.0
      ],
      "bbox_max": [
        260.0,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1249.3782958984375,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": 724.588623046875,
      "bbox_min": [
        120.0,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -1078.5234375,
      "bbox_min": [
        120.0,
        1249.3782958984375,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1249.3782958984375,
        60.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        0.2588256597518921,
        0.0
      ],
      "plane_d": -78.86228942871094,
      "bbox_min": [
        250.6217041015625,
        1240.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        253.30126953125,
        1250.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 581.1431274414062,
      "bbox_min": [
        250.6217041015625,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        253.30126953125,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 269.9999694824219,
      "bbox_min": [
        260.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        7438.0654296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        270.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        7436.076171875,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        270.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        7436.076171875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1301.3914794921875,
      "bbox_min": [
        270.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        270.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        270.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        270.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1241.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        270.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        270.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1301.3914794921875,
      "bbox_min": [
        270.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        7436.076171875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        270.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1309.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        270.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        7436.076171875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        270.0,
        7428.11962890625,
        60.0
      ],
      "bbox_max": [
        310.0,
        7436.076171875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        270.0,
        7438.0654296875,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        260.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        270.0,
        7438.0654296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        260.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        270.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        260.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        270.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        270.0,
        7438.0654296875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        260.0,
        7436.076171875,
        60.0
      ],
      "bbox_max": [
        270.0,
        7438.0654296875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        260.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        270.0,
        1250.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        310.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        7428.11962890625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        310.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        5422.169921875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        310.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        360.0,
        730.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        921.0000610351562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        500.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        500.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        500.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        602.2073974609375,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        500.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        602.2073974609375,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        550.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        550.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        500.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        602.2073974609375,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        600.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        500.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        504.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1449.9998779296875,
      "bbox_min": [
        500.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        504.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 293.37213134765625,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 526.0,
      "bbox_min": [
        526.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        536.0,
        1450.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        526.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        536.0,
        1450.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1449.9998779296875,
      "bbox_min": [
        526.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        536.0,
        1450.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        480.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        480.0,
        1111.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        480.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        1459.0001220703125,
        78.0
      ],
      "bbox_max": [
        480.0,
        1460.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        310.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        310.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1415.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        390.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1415.9998779296875,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        390.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1415.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        390.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        390.0,
        1415.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1459.0001220703125,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        310.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        390.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1425.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1310.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        340.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        440.0,
        1110.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        477.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1111.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        477.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        477.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        310.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        340.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.948459267616272,
        -0.020618680864572525,
        0.3162277638912201
      ],
      "plane_d": 291.75433349609375,
      "bbox_min": [
        -550.0,
        540.0,
        79.99999237060547
      ],
      "bbox_max": [
        550.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -550.0,
        1158.39990234375,
        79.99999237060547
      ],
      "bbox_max": [
        -173.942138671875,
        7375.61865234375,
        799.2634887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -414.7947692871094,
        7327.70947265625,
        80.0
      ],
      "bbox_max": [
        -173.942138671875,
        7375.61865234375,
        799.2634887695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -550.0,
        1158.39990234375,
        80.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -434.5,
        1158.39990234375,
        120.0
      ],
      "bbox_max": [
        -399.5,
        1219.021728515625,
        460.0666198730469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -550.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        0.16439898312091827
      ],
      "plane_d": 1380.951416015625,
      "bbox_min": [
        -540.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -540.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        -533.3333129882812,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -447.8142395019531,
        540.0,
        79.99999237060547
      ],
      "bbox_max": [
        550.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        -447.8142395019531,
        540.0,
        79.99999237060547
      ],
      "bbox_max": [
        550.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        -447.8142395019531,
        540.0,
        79.99999237060547
      ],
      "bbox_max": [
        550.0,
        5978.5498046875,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -447.8142395019531,
        540.0,
        79.99999237060547
      ],
      "bbox_max": [
        550.0,
        1719.423583984375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -447.8142395019531,
        850.556396484375,
        79.99999237060547
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        540.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -447.8142395019531,
        850.556396484375,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -447.8142395019531,
        1101.0794677734375,
        351.13873291015625
      ],
      "bbox_max": [
        -309.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -447.8142395019531,
        1123.759033203125,
        400.0
      ],
      "bbox_max": [
        -379.50006103515625,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1123.759033203125,
        400.0
      ],
      "bbox_max": [
        -379.50006103515625,
        1158.39990234375,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -399.5,
        1101.0794677734375,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        450.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -369.4998779296875,
        1210.361328125,
        400.0
      ],
      "bbox_max": [
        -309.5,
        1210.361328125,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        850.556396484375,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        850.556396484375,
        120.00611877441406
      ],
      "bbox_max": [
        -254.5,
        1006.4411010742188,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5,
        971.800048828125,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        971.800048828125,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1430.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        80.0
      ],
      "bbox_max": [
        -144.5,
        1430.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        80.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1219.021728515625,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1210.361328125,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -309.5,
        1210.361328125,
        400.0
      ],
      "bbox_max": [
        -279.5001220703125,
        1210.361328125,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        0.0
      ],
      "plane_d": -363.1294250488281,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -295.0,
        971.800048828125,
        80.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1219.021728515625,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -295.0,
        1045.8167724609375,
        80.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1219.021728515625,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -300.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -256.6857604980469,
        1430.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -300.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        -260.53472900390625,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -300.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        -0.0,
        -0.9284767508506775
      ],
      "plane_d": 272.97216796875,
      "bbox_min": [
        -266.3082580566406,
        1000.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        210.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        260.0,
        1604.025634765625,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -266.3082580566406,
        1050.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -266.3082580566406,
        1050.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1490.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -266.3082580566406,
        1050.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1490.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -256.8782043457031,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1430.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -50.0,
        1413.3333740234375,
        80.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -50.0,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1413.6666259765625,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        22.5,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1250.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -266.3082580566406,
        1210.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -260.53472900390625,
        1210.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        22.5,
        1210.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3205961585044861,
        0.0,
        -0.9472160339355469
      ],
      "plane_d": 67.76238250732422,
      "bbox_min": [
        30.909090042114258,
        1210.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1240.0,
        104.53845977783203
      ],
      "bbox_max": [
        120.0,
        1270.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1240.0,
        104.53845977783203
      ],
      "bbox_max": [
        120.0,
        1270.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        112.15384674072266
      ],
      "bbox_max": [
        120.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        112.15385437011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        97.5,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        112.15385437011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        82.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        108.76923370361328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        10.0,
        1240.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1265.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1316.54541015625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        22.5,
        1265.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        10.0,
        1200.0,
        126.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1265.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1348.1817626953125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        22.5,
        1265.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -139.87289428710938,
      "bbox_min": [
        110.0,
        1200.0,
        126.0
      ],
      "bbox_max": [
        260.0,
        1360.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        126.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        139.87289428710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        126.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        139.87289428710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        139.87289428710938
      ],
      "bbox_max": [
        120.0,
        1265.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        139.87289428710938
      ],
      "bbox_max": [
        120.0,
        1250.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        10.0,
        1050.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1250.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        35.0,
        1348.1817626953125,
        155.0
      ],
      "bbox_max": [
        110.0,
        1513.9443359375,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -37.0,
      "bbox_min": [
        35.0,
        1490.0,
        211.52786254882812
      ],
      "bbox_max": [
        93.0,
        1513.9443359375,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5218772888183594,
        -0.8530205488204956
      ],
      "plane_d": 970.2698364257812,
      "bbox_min": [
        35.0,
        1504.5,
        211.52786254882812
      ],
      "bbox_max": [
        37.0,
        1513.4443359375,
        217.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 217.0,
      "bbox_min": [
        89.0,
        1490.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1505.0,
        219.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9945054650306702,
        0.10468479245901108,
        0.0
      ],
      "plane_d": -248.99276733398438,
      "bbox_min": [
        92.0,
        1490.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1505.0,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -93.0,
      "bbox_min": [
        93.0,
        1490.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1495.0,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9943787455558777,
        0.09470273554325104,
        -0.04735136777162552
      ],
      "plane_d": -223.6878662109375,
      "bbox_min": [
        92.0,
        1495.0,
        217.0
      ],
      "bbox_max": [
        93.0,
        1505.0,
        219.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        22.5,
        1250.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1250.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        155.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        260.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        260.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.434683233499527,
        -0.35908615589141846,
        0.8258981108665466
      ],
      "plane_d": 130.44277954101562,
      "bbox_min": [
        270.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 239.99998474121094,
      "bbox_min": [
        270.0,
        1550.2734375,
        240.0
      ],
      "bbox_max": [
        310.0,
        1655.5635986328125,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        270.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        300.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1414.9998779296875,
      "bbox_min": [
        300.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1415.0,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        270.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        300.0,
        1415.0,
        240.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        260.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        270.0,
        1618.99169921875,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        260.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        270.0,
        1618.99169921875,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.434683233499527,
        -0.35908615589141846,
        0.8258981108665466
      ],
      "plane_d": 130.44277954101562,
      "bbox_min": [
        260.0,
        1460.0,
        334.7368469238281
      ],
      "bbox_max": [
        270.0,
        1472.105224609375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        310.0,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        550.0,
        1719.423583984375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        374.09832763671875,
        1197.03466796875,
        80.0
      ],
      "bbox_max": [
        550.0,
        1719.423583984375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        530.4696044921875,
        1197.03466796875,
        80.0
      ],
      "bbox_max": [
        550.0,
        1372.96533203125,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        550.0,
        1372.96533203125,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5257304906845093,
        0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": -740.1129150390625,
      "bbox_min": [
        530.4696044921875,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        550.0,
        1372.96533203125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        530.4696044921875,
        1197.03466796875,
        80.0
      ],
      "bbox_max": [
        550.0,
        1223.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        374.09832763671875,
        1285.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1719.423583984375,
        340.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.434683233499527,
        -0.35908615589141846,
        0.8258981108665466
      ],
      "plane_d": 130.44277954101562,
      "bbox_min": [
        374.09832763671875,
        1471.2445068359375,
        80.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        374.09832763671875,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 407.70465087890625,
      "bbox_min": [
        408.1647644042969,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        426.66668701171875,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        437.4075927734375,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        437.4075927734375,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        437.4075927734375,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        442.2814025878906,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1495.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        426.66668701171875,
        1500.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        434.15838623046875,
        1500.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1520.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        440.65679931640625,
        1500.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1500.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        426.66668701171875,
        1600.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1600.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 420.0,
      "bbox_min": [
        408.1647644042969,
        1520.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        118.39922332763672
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        420.0,
        1520.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        420.0,
        1520.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        434.15838623046875,
        1520.0,
        80.0
      ],
      "bbox_max": [
        436.66668701171875,
        1520.0,
        83.76245880126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        420.0,
        1600.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 1389.52392578125,
      "bbox_min": [
        408.1647644042969,
        1591.067138671875,
        80.0
      ],
      "bbox_max": [
        420.0,
        1600.0,
        118.39922332763672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        408.1647644042969,
        1600.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1600.0,
        105.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1657.302490234375,
        120.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1657.302490234375,
        120.0
      ],
      "bbox_max": [
        550.0,
        1675.537109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1463.3350830078125,
        140.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        550.0,
        1675.537109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        476.9701843261719,
        1495.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        505.25732421875,
        1285.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1675.537109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257304906845093,
        0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": -740.1129150390625,
      "bbox_min": [
        521.9630737304688,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        535.7269287109375,
        1362.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1657.302490234375,
        80.0
      ],
      "bbox_max": [
        550.0,
        1675.537109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        310.0,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        550.0,
        1704.845458984375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        140.0
      ],
      "bbox_max": [
        550.0,
        920.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        140.0
      ],
      "bbox_max": [
        550.0,
        869.8679809570312,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        310.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1704.845458984375,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.434683233499527,
        -0.35908615589141846,
        0.8258981108665466
      ],
      "plane_d": 130.44277954101562,
      "bbox_min": [
        310.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1704.845458984375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 440.0,
      "bbox_min": [
        310.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        464.86956787109375,
        1704.845458984375,
        313.6842041015625
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        464.86956787109375,
        1502.0213623046875,
        245.26315307617188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        1125.894775390625,
        98.0
      ],
      "bbox_max": [
        460.0,
        1502.0213623046875,
        245.26315307617188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        440.0,
        1145.5052490234375,
        98.0
      ],
      "bbox_max": [
        460.0,
        1471.2445068359375,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1425.0,
      "bbox_min": [
        440.0,
        1425.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1471.2445068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        440.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1471.2445068359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        440.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        440.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        453.653564453125,
        1502.0213623046875,
        245.26315307617188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        440.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1502.0213623046875,
        245.26315307617188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        440.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        442.2814025878906,
        1502.0213623046875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        440.0,
        1495.0,
        150.0
      ],
      "bbox_max": [
        442.2814025878906,
        1502.0213623046875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        453.653564453125,
        1471.2445068359375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        452.5699462890625,
        1471.2445068359375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        450.0,
        1460.0,
        190.0
      ],
      "bbox_max": [
        452.5699157714844,
        1471.244384765625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        453.653564453125,
        1463.3350830078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        453.653564453125,
        1463.3350830078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        453.653564453125,
        1463.3349609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        464.86956787109375,
        1502.0213623046875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        440.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        460.0,
        1502.0213623046875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        460.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        460.0,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        440.0,
        1405.0,
        85.0
      ],
      "bbox_max": [
        460.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        440.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1502.0213623046875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        440.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        440.65679931640625,
        1502.0213623046875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        310.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1704.845458984375,
        313.6842041015625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        310.0,
        1460.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1640.0001220703125,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        348.0,
        1510.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1529.0,
      "bbox_min": [
        348.0,
        1510.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1544.0,
      "bbox_min": [
        348.0,
        1540.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1540.0,
      "bbox_min": [
        348.0,
        1540.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1540.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1540.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1544.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        348.0,
        1510.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1529.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        348.0,
        1525.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1529.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1525.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1529.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1525.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1529.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1510.0,
      "bbox_min": [
        348.0,
        1510.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1514.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1510.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1514.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1510.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1514.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        348.0,
        1555.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1574.0,
      "bbox_min": [
        348.0,
        1555.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1589.0,
      "bbox_min": [
        348.0,
        1585.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1585.0,
      "bbox_min": [
        348.0,
        1585.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1585.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1585.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1589.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        348.0,
        1555.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1574.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1559.0,
      "bbox_min": [
        348.0,
        1555.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1559.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1555.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1559.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1555.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1559.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721364974975586,
        -0.0,
        0.8944272994995117
      ],
      "plane_d": -231.65667724609375,
      "bbox_min": [
        348.0,
        1570.0,
        84.0
      ],
      "bbox_max": [
        350.0,
        1574.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        348.0,
        1570.0,
        89.0
      ],
      "bbox_max": [
        350.0,
        1574.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        310.0,
        1460.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1640.0001220703125,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 239.99998474121094,
      "bbox_min": [
        310.0,
        1625.8948974609375,
        240.0
      ],
      "bbox_max": [
        315.64971923828125,
        1640.0001220703125,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        310.0,
        1495.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1495.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        350.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1704.845458984375,
        240.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        -0.0,
        -0.5547001957893372
      ],
      "plane_d": 407.70465087890625,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        390.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1520.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        390.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1520.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        390.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1520.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        426.66668701171875,
        1510.0,
        83.76245880126953
      ],
      "bbox_max": [
        437.4075927734375,
        1520.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        426.66668701171875,
        1520.0,
        83.76245880126953
      ],
      "bbox_max": [
        434.15838623046875,
        1520.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        396.66668701171875,
        1495.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1510.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        426.66668701171875,
        1500.0,
        95.0
      ],
      "bbox_max": [
        440.0,
        1510.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38461536169052124,
        -0.0,
        -0.9230769276618958
      ],
      "plane_d": 268.4615173339844,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        390.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        396.66668701171875,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 420.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1600.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        420.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1520.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        420.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        436.6667175292969,
        1520.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        420.0,
        1520.0,
        80.0
      ],
      "bbox_max": [
        434.15838623046875,
        1520.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 125.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1600.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        406.5,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9294481873512268,
        -0.36895260214805603,
        0.0
      ],
      "plane_d": 924.9774169921875,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        406.5,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9294481873512268,
        0.36895260214805603,
        0.0
      ],
      "plane_d": -169.33602905273438,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        406.5,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3967546224594116,
        -0.9179248213768005,
        0.0
      ],
      "plane_d": 1529.015625,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        403.1317138671875,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3967546224594116,
        0.9179248213768005,
        0.0
      ],
      "plane_d": -1193.54931640625,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        403.1317138671875,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        395.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1471.0,
      "bbox_min": [
        390.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        395.0,
        1471.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1189.8319091796875,
      "bbox_min": [
        390.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        420.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 1389.52392578125,
      "bbox_min": [
        390.0,
        1510.0,
        80.0
      ],
      "bbox_max": [
        411.0671691894531,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        390.0,
        1510.0,
        80.0
      ],
      "bbox_max": [
        410.0,
        1600.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": -470.0,
      "bbox_min": [
        390.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        410.0,
        1590.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": 722.3076782226562,
      "bbox_min": [
        390.0,
        1578.0,
        120.0
      ],
      "bbox_max": [
        410.0,
        1590.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        350.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        390.0,
        1704.845458984375,
        240.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        -0.5547001957893372
      ],
      "plane_d": -232.9740753173828,
      "bbox_min": [
        350.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1704.845458984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        350.0,
        1471.0,
        190.0
      ],
      "bbox_max": [
        380.0,
        1704.845458984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        365.8096618652344,
        1675.537109375,
        240.0
      ],
      "bbox_max": [
        380.0,
        1704.845458984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1471.0,
      "bbox_min": [
        350.0,
        1471.0,
        190.0
      ],
      "bbox_max": [
        380.0,
        1471.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38461536169052124,
        0.0,
        -0.9230769276618958
      ],
      "plane_d": -27.692298889160156,
      "bbox_min": [
        350.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 125.0,
      "bbox_min": [
        350.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        350.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        363.5,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9294481873512268,
        -0.36895260214805603,
        0.0
      ],
      "plane_d": 209.30230712890625,
      "bbox_min": [
        363.5,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9294481873512268,
        0.36895260214805603,
        0.0
      ],
      "plane_d": -885.0111083984375,
      "bbox_min": [
        363.5,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3967546224594116,
        -0.9179248213768005,
        0.0
      ],
      "plane_d": 1223.5146484375,
      "bbox_min": [
        366.8682861328125,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3967546224594116,
        0.9179248213768005,
        0.0
      ],
      "plane_d": -1499.0504150390625,
      "bbox_min": [
        366.8682861328125,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        375.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1495.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1471.0,
      "bbox_min": [
        375.0,
        1471.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1471.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        350.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1189.8319091796875,
      "bbox_min": [
        350.0,
        1500.0,
        105.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 1389.52392578125,
      "bbox_min": [
        350.0,
        1510.0,
        105.0
      ],
      "bbox_max": [
        380.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": -470.0,
      "bbox_min": [
        360.0,
        1510.0,
        120.0
      ],
      "bbox_max": [
        380.0,
        1590.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": 722.3076782226562,
      "bbox_min": [
        360.0,
        1578.0,
        120.0
      ],
      "bbox_max": [
        380.0,
        1590.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 125.0,
      "bbox_min": [
        380.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        390.0,
        1686.68212890625,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        380.0,
        1460.0,
        125.0
      ],
      "bbox_max": [
        390.0,
        1686.68212890625,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        380.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        390.0,
        1686.68212890625,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        380.0,
        1676.076171875,
        240.0
      ],
      "bbox_max": [
        383.2369384765625,
        1686.68212890625,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        380.0,
        1470.0,
        190.0
      ],
      "bbox_max": [
        390.0,
        1495.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        380.0,
        1495.0,
        190.0
      ],
      "bbox_max": [
        390.0,
        1495.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        380.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        390.0,
        1510.0,
        150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        380.0,
        1510.0,
        140.0
      ],
      "bbox_max": [
        390.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        380.0,
        1460.0,
        200.0
      ],
      "bbox_max": [
        390.0,
        1470.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        380.0,
        1470.0,
        80.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        380.0,
        1470.0,
        80.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": -1189.8319091796875,
      "bbox_min": [
        380.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320502638816833,
        -0.5547001957893372
      ],
      "plane_d": 1389.52392578125,
      "bbox_min": [
        380.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": -470.0,
      "bbox_min": [
        380.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.38461536169052124,
        -0.9230769276618958
      ],
      "plane_d": 722.3076782226562,
      "bbox_min": [
        380.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        380.0,
        1500.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        380.0,
        1600.0,
        95.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        380.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        390.0,
        1600.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -81.5,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 381.0,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1569.8717041015625,
        81.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -389.0,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1569.8717041015625,
        81.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1569.8717041015625,
        81.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1569.8717041015625,
      "bbox_min": [
        381.0,
        1569.8717041015625,
        80.0
      ],
      "bbox_max": [
        389.0,
        1569.8717041015625,
        81.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1530.1282958984375,
      "bbox_min": [
        381.0,
        1530.1282958984375,
        80.0
      ],
      "bbox_max": [
        389.0,
        1545.0,
        81.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1545.0,
      "bbox_min": [
        381.0,
        1545.0,
        80.0
      ],
      "bbox_max": [
        389.0,
        1545.0,
        81.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        -0.0,
        0.1414213627576828
      ],
      "plane_d": -393.6463623046875,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        0.0,
        0.1414213627576828
      ],
      "plane_d": 368.6147766113281,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1569.87158203125,
      "bbox_min": [
        384.0,
        1569.8717041015625,
        81.5
      ],
      "bbox_max": [
        386.0,
        1569.8717041015625,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1530.128173828125,
      "bbox_min": [
        384.0,
        1530.1282958984375,
        81.5
      ],
      "bbox_max": [
        386.0,
        1545.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1544.9998779296875,
      "bbox_min": [
        384.0,
        1545.0,
        81.5
      ],
      "bbox_max": [
        386.0,
        1545.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        310.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1460.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        310.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1460.0,
        240.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        310.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1340.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1340.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        400.0,
        1340.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1124.2998046875,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        310.0,
        1390.0,
        175.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        310.0,
        1390.0,
        175.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        435.0,
        1410.0,
        175.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        350.0,
        1390.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1415.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -806.1017456054688,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        310.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        200.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        330.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1340.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        330.0,
        1370.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        330.0,
        1370.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        330.0,
        1370.0,
        185.0
      ],
      "bbox_max": [
        330.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1350.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1360.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        330.0,
        1360.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        350.0,
        1389.9951171875,
        190.0
      ],
      "bbox_max": [
        440.0,
        1399.9998779296875,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        350.0,
        1390.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1399.9998779296875,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        310.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1460.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        310.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        310.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1460.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        350.0,
        1415.0,
        190.0
      ],
      "bbox_max": [
        350.0,
        1460.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 107.33126068115234,
      "bbox_min": [
        400.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        404.0,
        1415.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        310.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1240.0,
        218.0320587158203
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        310.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1415.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1150.105224609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1150.105224609375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        490.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1150.105224609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -332.8201599121094,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        447.00006103515625,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        447.00006103515625,
        1110.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        447.00006103515625,
        1120.0,
        98.0
      ],
      "bbox_max": [
        451.5000305175781,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -168.07418823242188,
      "bbox_min": [
        450.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        451.5000305175781,
        1130.0,
        99.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1130.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 166.4100799560547,
      "bbox_min": [
        450.0,
        1110.0,
        99.00001525878906
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -168.07418823242188,
      "bbox_min": [
        451.5000305175781,
        1110.0,
        99.00001525878906
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        483.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        443.3913269042969,
        1130.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1150.105224609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        447.1913146972656,
        1130.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1150.105224609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        460.0,
        1130.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1150.105224609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        326.08697509765625,
        1310.0,
        180.04576110839844
      ],
      "bbox_max": [
        440.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        412.8260803222656,
        1310.0,
        180.04576110839844
      ],
      "bbox_max": [
        440.0,
        1415.0,
        240.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        412.8260803222656,
        1340.0,
        193.08924865722656
      ],
      "bbox_max": [
        440.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        412.8260803222656,
        1415.0,
        225.69793701171875
      ],
      "bbox_max": [
        440.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -806.1017456054688,
      "bbox_min": [
        416.13043212890625,
        1340.0,
        193.08924865722656
      ],
      "bbox_max": [
        440.0,
        1350.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        426.86956787109375,
        1340.0,
        193.08924865722656
      ],
      "bbox_max": [
        440.0,
        1340.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        490.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1301.1802978515625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        490.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        1301.1802978515625,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        490.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        550.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        490.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        550.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        490.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        550.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        500.0,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        535.7269287109375,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        500.0,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        535.7269287109375,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        500.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        510.5146179199219,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        550.0,
        869.8679809570312,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        7380.38037109375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        550.0,
        869.8679809570312,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        6140.26513671875,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        550.0,
        869.8679809570312,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        550.0,
        1360.6046142578125,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1394.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        582.7122802734375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        550.0,
        1360.6046142578125,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        550.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        550.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        550.0,
        1607.625244140625,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1607.625244140625,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1634.350341796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        550.0,
        1589.77294921875,
        140.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        550.0,
        1589.77294921875,
        140.0
      ],
      "bbox_max": [
        584.3502807617188,
        1657.302490234375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        550.0,
        1634.350341796875,
        140.0
      ],
      "bbox_max": [
        584.3502807617188,
        1657.302490234375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1607.625244140625,
        140.0
      ],
      "bbox_max": [
        602.2073974609375,
        1634.350341796875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        550.0,
        1360.6046142578125,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1657.302490234375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        579.4630737304688,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        596.47607421875,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        550.0,
        869.8679809570312,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1209.3953857421875,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        550.0,
        869.8679809570312,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1209.3953857421875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        550.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        550.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        602.2073974609375,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        550.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        550.0,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        582.7122802734375,
        1209.3953857421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        550.0,
        869.8679809570312,
        190.0
      ],
      "bbox_max": [
        602.2073974609375,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        600.1320190429688,
        920.0,
        190.0
      ],
      "bbox_max": [
        602.2073974609375,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        261.3146057128906,
        60.0
      ],
      "bbox_max": [
        310.0,
        540.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        261.3146057128906,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        602.2073974609375,
        586.3495483398438,
        60.0
      ],
      "bbox_max": [
        650.0,
        7369.99560546875,
        976.300048828125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        602.2073974609375,
        920.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        7369.99560546875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        602.2073974609375,
        7360.4892578125,
        60.0
      ],
      "bbox_max": [
        650.0,
        7369.99560546875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        602.2073974609375,
        920.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        602.2073974609375,
        920.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        602.2073974609375,
        1130.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        602.2073974609375,
        1130.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        602.2073974609375,
        1130.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1170.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        602.2073974609375,
        1130.0,
        78.0
      ],
      "bbox_max": [
        615.0,
        1150.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 605.0,
      "bbox_min": [
        605.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        605.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        602.2073974609375,
        1420.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        602.2073974609375,
        1420.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        602.2073974609375,
        1440.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        602.2073974609375,
        1382.40087890625,
        80.0
      ],
      "bbox_max": [
        650.0,
        7369.99560546875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        602.2073974609375,
        1382.40087890625,
        80.0
      ],
      "bbox_max": [
        650.0,
        6288.3056640625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1382.40087890625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1620.474609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        1382.40087890625,
        96.81153869628906
      ],
      "bbox_max": [
        650.0,
        1384.3714599609375,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        647.2877197265625,
        1382.40087890625,
        96.81153869628906
      ],
      "bbox_max": [
        650.0,
        1384.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        602.2073974609375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        1620.474609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        625.537109375,
        1460.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1620.474609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        625.537109375,
        1460.0,
        190.0
      ],
      "bbox_max": [
        650.0,
        1620.474609375,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        602.2073974609375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        1607.625244140625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        602.2073974609375,
        1460.0,
        120.0
      ],
      "bbox_max": [
        647.95654296875,
        1607.625244140625,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        602.2073974609375,
        1460.0,
        120.0
      ],
      "bbox_max": [
        647.95654296875,
        1607.625244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        602.2073974609375,
        1460.0,
        120.0
      ],
      "bbox_max": [
        647.95654296875,
        1500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        640.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        647.95654296875,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        602.2073974609375,
        1460.0,
        120.0
      ],
      "bbox_max": [
        640.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        602.2073974609375,
        1460.0,
        140.0
      ],
      "bbox_max": [
        647.95654296875,
        1607.625244140625,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        640.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        647.95654296875,
        1500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        640.0,
        1460.0,
        190.0
      ],
      "bbox_max": [
        647.95654296875,
        1500.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        602.2073974609375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        1607.625244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        640.0,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        647.2877197265625,
        1384.3714599609375,
        83.30496978759766
      ],
      "bbox_max": [
        650.0,
        1392.718994140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        602.2073974609375,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        640.0,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        602.2073974609375,
        920.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        602.2073974609375,
        920.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        602.2073974609375,
        920.0,
        120.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        602.2073974609375,
        920.0,
        160.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        602.2073974609375,
        1090.0,
        160.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        602.2073974609375,
        920.0,
        190.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        240.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: cabf",
      "entity_class": "CSlidingDoor",
      "piece_name": "cabf",
      "offset": 5858,
      "centroid": [
        385.0,
        1495.0,
        87.5
      ],
      "bbox_min": [
        380.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        390.0,
        1495.0,
        95.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 0.0,
        "height_z": 15.0,
        "door_width": 10.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          380.0,
          1495.0,
          80.0
        ],
        [
          390.0,
          1495.0,
          80.0
        ],
        [
          390.0,
          1495.0,
          95.0
        ],
        [
          380.0,
          1495.0,
          95.0
        ]
      ],
      "plane_distance": -1495.0,
      "authentic_texture": "elevdr1"
    },
    {
      "tag": "CSlidingDoor piece: dr1-02",
      "entity_class": "CSlidingDoor",
      "piece_name": "dr1-02",
      "offset": 9437,
      "centroid": [
        385.0,
        1470.5,
        145.0
      ],
      "bbox_min": [
        380.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        390.0,
        1471.0,
        150.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          380.0,
          1471.0,
          140.0
        ],
        [
          380.0,
          1471.0,
          150.0
        ],
        [
          380.0,
          1470.0,
          140.0
        ],
        [
          380.0,
          1470.0,
          150.0
        ],
        [
          390.0,
          1471.0,
          150.0
        ],
        [
          390.0,
          1471.0,
          140.0
        ],
        [
          390.0,
          1470.0,
          140.0
        ],
        [
          390.0,
          1470.0,
          150.0
        ]
      ],
      "plane_distance": -1471.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: dr1-03",
      "entity_class": "CSlidingDoor",
      "piece_name": "dr1-03",
      "offset": 10568,
      "centroid": [
        385.0,
        1470.5,
        195.0
      ],
      "bbox_min": [
        380.0,
        1470.0,
        190.0
      ],
      "bbox_max": [
        390.0,
        1471.0,
        200.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          380.0,
          1471.0,
          190.0
        ],
        [
          380.0,
          1471.0,
          200.0
        ],
        [
          380.0,
          1470.0,
          190.0
        ],
        [
          380.0,
          1470.0,
          200.0
        ],
        [
          390.0,
          1471.0,
          200.0
        ],
        [
          390.0,
          1471.0,
          190.0
        ],
        [
          390.0,
          1470.0,
          190.0
        ],
        [
          390.0,
          1470.0,
          200.0
        ]
      ],
      "plane_distance": -1471.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: rech",
      "entity_class": "CSlidingDoor",
      "piece_name": "rech",
      "offset": 12017,
      "centroid": [
        419.8999938964844,
        1551.25,
        84.0
      ],
      "bbox_min": [
        419.8999938964844,
        1550.0,
        83.0
      ],
      "bbox_max": [
        419.8999938964844,
        1552.5,
        85.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 2.5,
        "height_z": 2.0,
        "door_width": 2.5,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          419.8999938964844,
          1550.0,
          83.0
        ],
        [
          419.8999938964844,
          1552.5,
          85.0
        ],
        [
          419.8999938964844,
          1550.0,
          85.0
        ],
        [
          419.8999938964844,
          1552.5,
          83.0
        ]
      ],
      "plane_distance": 419.9
    }
  ],
  "tutorial_messages": []
}